import type { Dictionary } from "@/lib/i18n/dictionaries/en";

const id: Dictionary = {
  // ---- /citation-styles/alphabetical/<letter> ----
  styleDirectory: {
    notFoundTitle: "Direktori gaya sitasi tidak ditemukan",
    metaTitle: "Gaya sitasi yang diawali {label}",
    metaDescription:
      "Jelajahi {count} gaya Citation Style Language yang diawali {label}. Buka gaya apa pun untuk melihat contoh sitasi nyata dan generator gratis.",
    ogSubtitle: "{count} gaya dengan contoh dan generator khusus.",
    ogKind: "Direktori A–Z",
    schemaName: "Gaya sitasi yang diawali {label}",
    schemaDescription:
      "Direktori alfabetis {count} gaya Citation Style Language yang diawali {label}.",
    breadcrumbStyles: "Gaya sitasi",
    heading: "Gaya sitasi yang diawali {label}",
    intro:
      "Jelajahi semua {count} gaya di bagian katalog CSL ini. Setiap halaman berisi contoh terformat dari gaya tersebut dan generator sitasi gratis.",
    navLabel: "Gaya sitasi A sampai Z",
    listHeading: "Semua gaya yang diawali {label}",
  },
  nav: {
    tools: "Alat",
    guides: "Panduan",
    styles: "Semua gaya",
    bibliography: "Daftar pustaka saya",
    search: "Cari",
    glossary: "Glosarium",
    home: "Beranda",
    menu: "Menu",
  },

  home: {
    title: "Pembuat sitasi gratis",
    subtitle: "Diperbarui untuk 2026",
    intro:
      "Tempel DOI, URL, atau entri BibTeX — atau cari buku — lalu dapatkan sitasi yang diformat dengan benar dalam gaya APA, MLA, Chicago, Vancouver, Harvard, dan ribuan gaya lainnya. Sepenuhnya gratis, tanpa langganan berbayar, tanpa pendaftaran.",
    browseAllStyles: "Jelajahi seluruh {count} gaya sitasi →",
    featuresHeading: "Semua yang Anda butuhkan untuk menyitasi",
    featureStyles: "{count} gaya",
    featureStylesDetail: "APA, MLA, Chicago, dan lainnya",
    featureBibliographies: "Banyak daftar pustaka",
    featureBibliographiesDetail: "Tersusun per tugas",
    featureBookSearch: "Pencarian buku",
    featureBookSearchDetail: "Berdasarkan judul atau penulis",
    featureExport: "Ekspor ke mana saja",
    featureExportDetail: "BibTeX, Word, RIS, CSV",
    featureDarkMode: "Mode gelap",
    featureDarkModeDetail: "Nyaman di mata",
    featureNoSignup: "Tanpa pendaftaran",
    featureNoSignupDetail: "Gratis selamanya, tanpa langganan berbayar",
    aboutHeading: "Pembuat sitasi gratis untuk mahasiswa dan peneliti",
    aboutBody:
      "CitationEasy mendukung lebih dari 10.000 gaya sitasi akademik. Baik Anda memerlukan APA untuk psikologi, MLA untuk sastra, Chicago untuk sejarah, atau Vancouver untuk jurnal kedokteran, format diambil dari definisi resmi gaya itu sendiri — bukan dari perkiraan.",
    howItWorksHeading: "Cara kerjanya",
    howItWorksStep1:
      "Tempel DOI, URL, ISBN, ID PubMed atau arXiv, atau entri BibTeX; Anda juga bisa mencari buku berdasarkan judul.",
    howItWorksStep2:
      "Pilih gaya sitasi Anda. Ketik untuk mencari di antara seluruh {count} gaya.",
    howItWorksStep3:
      "Salin sitasi yang sudah jadi, atau simpan ke daftar pustaka dan ekspor ke Word, BibTeX, atau RIS.",
    privacyNote:
      "Daftar pustaka Anda disimpan di peramban Anda sendiri. Tanpa akun, dan tidak ada yang diunggah.",
  },

  hubs: {
    toolsTitle: "Alat menulis dan menyitasi gratis",
    toolsIntro:
      "{count} alat berbasis peramban untuk menulis dan menyitasi: pembuat sitasi untuk setiap jenis sumber, penghitung kata dan karakter, penilaian keterbacaan, perapi format, dan pengonversi. Semuanya gratis dan langsung jalan.",
    stylesTitle: "Jelajahi semua gaya sitasi",
    stylesIntro:
      "Seluruh {count} gaya dari proyek Citation Style Language, dapat dicari dan disaring menurut negara, bidang, dan disiplin akademik.",
    guidesTitle: "Panduan sitasi dan penulisan akademik",
    guidesIntro:
      "Panduan mendalam tentang cara menyitasi tiap jenis sumber, menilai apa yang Anda temukan, dan menulis lebih baik.",
    howToCiteTitle: "Cara menyitasi sumber apa pun",
    howToCiteIntro:
      "Halaman langkah demi langkah yang memasangkan setiap jenis sumber umum dengan gaya sitasi utama, masing-masing dengan contoh nyata.",
    faqTitle: "Tanya jawab seputar sitasi",
    faqIntro:
      "Jawaban singkat dan akurat untuk pertanyaan yang benar-benar ditanyakan mahasiswa saat menyitasi.",
    glossaryTitle: "Glosarium sitasi",
    glossaryIntro:
      "Definisi yang mudah dipahami untuk istilah yang muncul di panduan gaya dan lembar tugas.",
    openHub: "Buka",
  },

  styleLanding: {
    metaTitle: "Pembuat sitasi {style} gratis",
    metaDescription:
      "Buat sitasi {style} secara gratis. Tempel DOI, URL, ISBN, atau BibTeX dan dapatkan entri daftar pustaka serta sitasi dalam teks dengan format {style} yang benar.",
    heading: "Pembuat sitasi {style}",
    intro:
      "Buat sitasi {style} yang akurat untuk buku, artikel jurnal, dan situs web dengan satu klik. Gratis dan tanpa pendaftaran.",
    aboutHeading: "Tentang {style}",
    whenToUseHeading: "Kapan menggunakan {style}",
    factsHeading: "{style} sekilas",
    factEdition: "Edisi",
    factSystem: "Sistem sitasi",
    factInText: "Format dalam teks",
    factReferenceList: "Nama daftar",
    factFields: "Umum di",
    systemAuthorDate: "Penulis–tahun",
    systemNumbered: "Bernomor",
    systemFootnotes: "Catatan kaki",
    howToHeading: "Cara memakai pembuat sitasi {style} ini",
    howToStep1:
      "Tempel URL, DOI, ISBN, atau entri BibTeX di kotak di atas, atau cari buku berdasarkan judul.",
    howToStep2:
      "{style} sudah dipilih di halaman ini, jadi Anda bisa langsung membuat sitasi.",
    howToStep3:
      "Salin hasilnya ke dokumen Anda, atau simpan dan ekspor seluruh daftar nanti.",
    relatedHeading: "Sumber lain tentang {style}",
    englishOnlyNote:
      "Panduan {style} yang lebih rinci dan contoh per jenis sumber tersedia dalam bahasa Inggris.",
  },

  // The per-style pages at `/<locale>/citation-style/<slug>` — one per catalog style.
  //
  // The formatted examples the page is built around (the style's own output for a
  // fixed journal article, book and website) and the style's own name stay in
  // `src/data/citation-styles.ts` and `src/data/style-examples-generated.json`. They
  // are language-neutral: a citation rendered by the style's own CSL definition looks
  // the same whatever language the reader speaks, and "translating" one would make the
  // page wrong.
  //
  // The rest of what `src/data/**` supplies to these pages is NOT like that — see the
  // `generic*`, `discipline*` and `internationalLabel` keys below.
  citationStylePage: {
    notFoundTitle: "Gaya sitasi tidak ditemukan",
    metaTitle: "Pembuat Sitasi {style} - Format {style} Gratis",
    metaFormatAndFields:
      "{style} adalah gaya {format} yang digunakan di {fields}.",
    metaFormatOnly: "{style} adalah gaya {format}.",
    metaFieldsOnly: "{style} digunakan di {fields}.",
    metaPromiseNote:
      "Lihat catatan kaki {style} yang sebenarnya, lalu buat sitasi Anda sendiri secara gratis.",
    metaPromiseExamples:
      "Lihat contoh sitasi {style} yang sebenarnya untuk artikel jurnal, buku, dan situs web, lalu buat sitasi Anda sendiri secara gratis.",
    ogKindFormat: "Gaya {format}",
    ogKindDefault: "Gaya sitasi",
    // Joins the style's discipline list: "psychology, education and nursing".
    disciplineConjunction: "dan",
    // ---- Data-derived facts that are nonetheless mail-merged prose ----
    //
    // Every entry in `src/data/citation-styles-generated.ts` carries exactly the
    // two sentences below with their own name spliced in, exactly one region value
    // ("International" — that is `internationalLabel` above, reused rather than
    // duplicated), and discipline tokens drawn from a closed 26-word vocabulary. None
    // of that is a citation, so none of it is language-neutral the way the formatted
    // examples are. Left in `src/data/**` it renders English facts inside translated
    // chrome, which is precisely the hybrid page this tree exists to avoid.
    //
    // The page substitutes the two templates ONLY when a style's stored text is
    // byte-identical to the English template with its own name interpolated, so the
    // ~100 hand-curated styles keep their bespoke English descriptions instead of
    // being flattened into a generic sentence. `{name}` is the style's full name.
    genericDescription:
      "Gaya sitasi untuk {name}. Dari repositori Citation Style Language.",
    genericWhenUsed:
      "Digunakan saat mengirimkan naskah atau menyitasi pada publikasi yang memakai gaya {name}.",

    // The 26 discipline tokens `style-examples-generated.json` uses. Each English
    // value is the exact string the page printed before these keys existed — the raw
    // token with hyphens turned into spaces — so `generic-base` reads "generic base"
    // and `political_science` keeps its underscore. An unknown token (a new one from
    // upstream CSL) falls back to that same prettified form rather than to a key name.
    disciplineAnthropology: "antropologi",
    disciplineAstronomy: "astronomi",
    disciplineBiology: "biologi",
    disciplineBotany: "botani",
    disciplineChemistry: "kimia",
    disciplineCommunications: "ilmu komunikasi",
    disciplineEngineering: "teknik",
    disciplineGenericBase: "umum",
    disciplineGeography: "geografi",
    disciplineGeology: "geologi",
    disciplineHistory: "sejarah",
    disciplineHumanities: "humaniora",
    disciplineLaw: "hukum",
    disciplineLinguistics: "linguistik",
    disciplineLiterature: "sastra",
    disciplineMath: "matematika",
    disciplineMedicine: "kedokteran",
    disciplinePhilosophy: "filsafat",
    disciplinePhysics: "fisika",
    disciplinePoliticalScience: "ilmu politik",
    disciplinePsychology: "psikologi",
    disciplineScience: "sains",
    disciplineSocialScience: "ilmu sosial",
    disciplineSociology: "sosiologi",
    disciplineTheology: "teologi",
    disciplineZoology: "zoologi",

    // Plain-language descriptions of the citation-format classes the CSL definitions
    // declare. `{format}` in the fallback is the raw class name from the data.
    formatClassAuthorDate:
      "gaya penulis–tahun: sitasi dalam teks mencantumkan nama penulis dan tahun, dan daftar pustaka diurutkan menurut abjad nama penulis",
    formatClassNumeric:
      "gaya bernomor: sumber diberi nomor sesuai urutan pertama kali disitasi, dan sitasi dalam teks memakai nomor tersebut",
    formatClassNote:
      "gaya berbasis catatan: sitasi muncul dalam catatan kaki atau catatan akhir, bukan dalam tanda kurung di teks",
    formatClassLabel:
      "gaya label: sitasi dalam teks memakai label ringkas yang dibentuk dari nama penulis dan tahun",
    formatClassAuthor:
      "gaya hanya-penulis: sitasi dalam teks mencantumkan nama penulis, dengan detail lengkap di daftar pustaka",
    formatClassOther: "gaya {format}",
    breadcrumbStyles: "Gaya sitasi",
    internationalLabel: "Internasional",
    heading: "Pembuat sitasi {style}",
    intro:
      "Buat sitasi {style} yang akurat untuk buku, artikel, dan situs web hanya dengan satu klik.",
    examplesHeading: "Contoh sitasi {style}",
    examplesIntro: "Tiga sumber yang sama, diformat dalam gaya {style}:",
    examplesIntroWithFormat:
      "Tiga sumber yang sama, diformat dalam gaya {style} — {format}:",
    examplesNoteOnlyIntro:
      "{style} adalah gaya berbasis catatan: gaya ini tidak memiliki daftar pustaka, dan setiap sitasi berupa catatan kaki. Berikut contoh artikel jurnal kami yang disitasi dengan gaya {style}:",
    labelJournalArticle: "Artikel jurnal",
    labelBook: "Buku",
    labelWebsite: "Situs web",
    labelFootnote: "Catatan kaki (artikel jurnal)",
    labelInText: "Sitasi dalam teks (untuk artikel jurnal)",
    aboutHeading: "Tentang {style}",
    whenToUseLabel: "Kapan menggunakan {style}:",
    commonInLabel: "Umum di:",
    subjectAreasLabel: "Bidang studi:",
    formattingRulesLabel: "Aturan format:",
    parentStylePrefix: "{style} mengikuti format",
    parentStyleSuffix: ", gaya induk yang menjadi dasarnya.",
    howToHeading: "Cara memakai pembuat sitasi {style} ini",
    howToBody:
      'Tempel DOI, URL artikel berita atau halaman web, atau teks BibTeX mentah ke kotak di atas. Anda juga bisa mencari buku berdasarkan judul atau penulis, lalu menyitasinya lewat ISBN. Pilih "{style}" pada menu gaya (sudah terpilih otomatis di halaman ini), lalu klik "Buat sitasi." Salin hasilnya ke daftar pustaka Anda. Anda dapat mengedit entri yang dihasilkan (misalnya memperbaiki judul atau menambahkan tanggal) sebelum menyalinnya.',
    faqHeading: "Pertanyaan yang sering diajukan tentang {style}",
    faqWhatIsQ: "Apa itu {style}?",
    faqWhenQ: "Kapan saya harus menggunakan {style}?",
    faqInTextQ: "Seperti apa sitasi dalam teks pada gaya {style}?",
    faqInTextA:
      "{style} adalah {format}. Sitasi untuk contoh artikel jurnal kami dalam teks akan terlihat seperti: {example}",
    faqReferenceQ: "Seperti apa entri daftar pustaka pada gaya {style}?",
    faqReferenceA:
      "Artikel jurnal yang diformat dengan gaya {style} akan terlihat seperti ini: {example}",
    faqWhereQ: "Di mana {style} umum digunakan?",
    faqWhereA: "{style} digunakan {region}. {whenUsed}",
    faqRegionDefault: "secara internasional",
    faqGenerateQ: "Bagaimana cara membuat sitasi {style}?",
    faqGenerateA:
      "Gunakan pembuat sitasi gratis di halaman ini: tempel DOI, URL (misalnya artikel berita), atau BibTeX, atau cari buku berdasarkan judul atau penulis. Pilih {style} sebagai gaya sitasi, lalu klik Buat untuk mendapatkan rujukan terformat yang bisa Anda salin ke tulisan atau daftar pustaka Anda.",
    footerSupports:
      "mendukung banyak gaya sitasi dari seluruh dunia. Pembuat sitasi kami menggunakan gaya Citation Style Language (CSL) dari",
    footerRepoLink: "repositori CSL resmi",
  },

  // The source × style pages at `/<locale>/how-to-cite/<slug>` — 1,290 combinations.
  //
  // Same division as above: the citation templates, the worked examples generated from
  // each style's own CSL definition, the in-text samples and the hand-checked
  // formatting rules stay in the page module and in
  // `src/data/how-to-cite-examples-generated.json`. They are the citations themselves,
  // not prose about them. Source names, style names and editions come from
  // `src/data/how-to-cite.ts` and arrive here as placeholder values.
  crossLinks: {
    generateHeading: "Buat sitasi ini",
    generateBody:
      "Tempel URL, DOI, ISBN, atau detail sumber dan dapatkan sitasi {style} yang siap pakai untuk {source}.",
    generateCta: "Buka {tool} →",
    guideHeading: "Pelajari lebih lanjut",
    guideCta: "Baca panduan lengkapnya: {guide}",
    howToCiteHeading: "Cara mengutip {source} dalam setiap gaya",
    howToCiteBody:
      "Aturan format, templat, dan contoh lengkap untuk gaya yang paling sering diminta.",
    howToCiteMore: "Semua jenis sumber dan gaya →",
    citeNowHeading: "Kutip {source} dalam {style} sekarang",
    citeNowHowTo: "Aturan format dan contoh lengkap",
    citeNowTool: "Buat dengan {tool}",
    citeNowHub: "Generator sitasi {style}",
    hubSourcesHeading: "Cara mengutip sumber umum dalam {style}",
    hubGuidesHeading: "Panduan {style}",
    hubCompareHeading: "Bandingkan {style} dengan gaya lain",
    moreInCollection: "Lainnya di {collection}",
    seeAllInCollection: "Lihat semua di {collection}",
  },

  howToCitePage: {
    notFoundTitle: "Tidak ditemukan",
    title: "Cara menyitasi {source} dengan gaya {style} ({edition})",
    metaTitle:
      "Cara menyitasi {source} dengan gaya {style} [{edition}, diperbarui 2026]",
    metaDescription:
      "Pelajari cara menyitasi {description} dengan format {style} ({edition}). Contoh, templat, dan panduan sitasi dalam teks — gratis.",
    keywordCite: "menyitasi {source} {style}",
    keywordCitation: "sitasi {style} {source}",
    keywordHowTo: "cara menyitasi {source}",
    keywordExample: "contoh sitasi {style}",
    keywordReference: "rujukan {source} {style}",
    // What each style calls the list at the back of the paper, in the two casings the
    // prose needs. MLA says "Works Cited", Chicago and the legal styles "Bibliography".
    refListWorksCited: "Daftar Karya yang Dikutip",
    refListWorksCitedPage: "halaman Daftar Karya yang Dikutip",
    refListBibliography: "Daftar Pustaka",
    refListBibliographyLower: "daftar pustaka",
    refListReferenceList: "Daftar Referensi",
    refListReferenceListLower: "daftar referensi",
    backLink: "← Semua panduan sitasi",
    lead: "Pelajari cara menyitasi {description} dengan format {style} ({edition}). Panduan ini mencakup format daftar pustaka, contoh sitasi dalam teks, dan aturan format penting.",
    referenceFormatHeading: "Format {list} {style}",
    referenceFormatIntro:
      "Berikut format {style} standar untuk menyitasi {source} pada {list} Anda:",
    noTemplateNote: "Ikuti templat {style} standar untuk jenis sumber ini.",
    workedHeading: "Contoh {style} untuk {source}",
    workedIntro:
      "Rujukan {style} lengkap untuk {source}, diformat menggunakan definisi gaya CSL {style} resmi — mesin yang sama yang menggerakkan pembuat sitasi di situs ini:",
    workedNoteOnlyIntro:
      "Dalam {style}, {source} tidak dicantumkan di {list} — sumber ini hanya disitasi dalam catatan. Berikut catatan tersebut, diformat menggunakan definisi gaya CSL {style} resmi:",
    workedOscolaNote:
      "Keluaran OSCOLA yang dihasilkan di situs ini mengikuti gaya CSL edisi ke-4, karena belum ada gaya CSL edisi ke-5 yang diterbitkan di repositori Citation Style Language. Sesuaikan secara manual: ganti setiap ibid dengan nama singkat dan (n X), gunakan pengenal pengadilan edisi ke-5, tulis bentuk singkat undang-undang dalam tanda kutip tunggal, dan utamakan tautan permanen atau DOI daripada tanggal akses",
    workedCheckedIntro:
      "Rujukan {style} lengkap untuk {source}, ditulis secara manual dan diperiksa berdasarkan pedoman resmi {style} untuk sumber ini:",
    workedCheckedNoteOnlyIntro:
      "Dalam {style}, {source} tidak dicantumkan di {list} — sumber ini hanya disitasi dalam catatan. Berikut catatan tersebut, ditulis secara manual dan diperiksa berdasarkan pedoman resmi {style}:",
    workedInTextLabel: "Sitasi dalam teks yang sesuai:",
    inTextHeading: "Sitasi dalam teks {style}",
    inTextIntro:
      "Gunakan salah satu format berikut saat merujuk sumber ini dalam tulisan Anda:",
    inTextParenthetical: "Parentetik",
    inTextNarrative: "Naratif",
    rulesHeading: "Aturan format penting {style}",
    stepsHeading: "Panduan langkah demi langkah",
    step1Label: "Kumpulkan informasi sumber:",
    step1Body:
      "Kumpulkan nama penulis, judul, tanggal publikasi, dan URL atau DOI untuk {source} Anda.",
    step2Label: "Format rujukannya:",
    step2Body:
      "Susun elemen-elemennya mengikuti templat {style} ({edition}) yang ditampilkan di atas.",
    step3Label: "Buat sitasi dalam teks:",
    step3Body:
      "Tambahkan sitasi parentetik atau naratif dalam tulisan Anda di tempat Anda merujuk sumber ini.",
    step4Label: "Tambahkan ke {list} Anda:",
    step4Body:
      "Sertakan sitasi lengkap yang sudah diformat di akhir tulisan Anda.",
    step5Label: "Periksa kembali formatnya:",
    step5Body:
      "Pastikan huruf miring, tanda baca, kapitalisasi, dan indentasi gantung sudah sesuai dengan ketentuan {style}.",
    ctaHeading: "Buat sitasi ini secara otomatis",
    ctaBody:
      "Lewati pemformatan manual. Tempel DOI, URL, atau ISBN ke CitationEasy dan dapatkan sitasi {style} yang terformat sempurna dalam hitungan detik.",
    ctaButton: "Sitasi dengan {style} sekarang →",
    otherStylesHeading: "Sitasi {source} dengan gaya lain",
    comboLink: "{source} dengan {style}",
    otherSourcesHeading: "Sitasi sumber lain dengan {style}",
    resourcesHeading: "Sumber daya lainnya",
    resourceGenerator: "Pembuat sitasi gratis ({count} gaya)",
    resourceTools: "Alat menulis gratis",
    resourceCompare: "Bandingkan gaya sitasi",
    resourceGuides: "Semua panduan sitasi",
    resourceCheatSheets: "Lembar contekan (APA, MLA, Chicago)",
    resourceGlossary:
      "Glosarium sitasi (et al., ibid., DOI, indentasi gantung)",
    // HowTo structured data. Deliberately worded differently from the visible steps
    // above: the schema describes the task generically, the page walks the reader
    // through this particular source and style.
    schemaStep1Name: "Kumpulkan informasi sumber",
    schemaStep1Text:
      "Kumpulkan semua informasi yang diperlukan untuk {source} Anda, termasuk penulis, judul, tanggal, dan URL atau DOI.",
    schemaStep2Name: "Format dengan {style}",
    schemaStep2Text:
      "Ikuti aturan format {style} ({edition}) untuk menyusun elemen sitasi dalam urutan yang benar.",
    schemaStep3Name: "Buat sitasi dalam teks",
    schemaStep3Text:
      "Tambahkan sitasi dalam teks yang sesuai pada tulisan Anda menggunakan format {style}.",
    schemaStep4Name: "Tambahkan ke daftar pustaka",
    schemaStep4Text:
      "Sertakan sitasi lengkap di {list} Anda pada akhir tulisan.",
    faqHowQ: "Bagaimana cara menyitasi {source} dengan gaya {style}?",
    faqHowA:
      "Untuk menyitasi {source} dengan gaya {style} ({edition}), cantumkan penulis, judul, tanggal, dan lokasi sumber. Gunakan pembuat sitasi gratis kami untuk pemformatan otomatis.",
    faqFormatQ: "Apa format {style} untuk sitasi {source}?",
    faqFormatA: "Format {style} untuk {source} adalah: {example}",
    faqFormatFallback:
      "Format {style} membutuhkan elemen tertentu seperti penulis, judul, tanggal, dan lokasi sumber yang disusun dalam urutan tertentu.",
    faqInTextQ:
      "Seperti apa sitasi dalam teks untuk {source} dengan gaya {style}?",
    faqInTextA:
      "Dengan gaya {style}, sitasi dalam teks untuk contoh di atas adalah {example}",
  },

  // The 43 source types the how-to-cite pages are built from (`SOURCE_TYPES` in
  // `src/data/how-to-cite.ts`), in the five forms those pages print. Each form is a whole
  // phrase, never an article and a noun joined in code: an article agrees with its noun
  // in gender, number and case, elides in French and Italian, and has no counterpart
  // at all in Polish, Russian or Japanese.
  //
  // - `…Name` ("Book") is the type on its own, as a label: `howToCitePage.comboLink`.
  //   English also lower-cases it into the `keyword*` templates.
  // - `…Title` ("a Book") is the type as the object of "cite" in a title or heading:
  //   `title`, `metaTitle`, `workedHeading` and `otherStylesHeading`, plus
  //   `crossLinks.generateBody`, `howToCiteHeading` and `citeNowHeading`. Through
  //   `title` it is also the HowTo name, the OG card and every link to the page.
  // - `…Phrase` ("a book") is the same inside a sentence: `referenceFormatIntro`,
  //   `workedIntro`, `workedNoteOnlyIntro` and the five `faq*` questions and answers.
  // - `…Noun` ("book") is the bare noun inside a sentence, where English puts "your" in
  //   front of it: `step1Body` and `schemaStep1Text`. A translation also uses it in the
  //   `keyword*` templates, which read as search queries.
  // - `…Description` is what the type covers: `{description}` in `lead` and
  //   `metaDescription`.
  //
  // A language with case picks one case per form and words every template above around
  // it — German writes Title and Phrase in the accusative, Polish and Russian write Name
  // and Noun in the nominative. Changing a form's case means re-reading every template
  // that receives it. A key missing here falls back to the English data
  // (`howToCiteSourceForms`), so a new source type renders in English, not as a key.
  // Indonesian: no articles, case or classifiers. Name is sentence-cased; Title, Phrase and Noun are lower-case (proper names keep their capitals), so every form sits mid-sentence after "menyitasi" or "untuk".
  howToCiteSources: {
    websiteName: "Situs web",
    websiteTitle: "situs web",
    websitePhrase: "situs web",
    websiteNoun: "situs web",
    websiteDescription: "halaman web, artikel daring, dan konten web",

    bookName: "Buku",
    bookTitle: "buku",
    bookPhrase: "buku",
    bookNoun: "buku",
    bookDescription: "buku cetak dan buku elektronik",

    journalArticleName: "Artikel jurnal",
    journalArticleTitle: "artikel jurnal",
    journalArticlePhrase: "artikel jurnal",
    journalArticleNoun: "artikel jurnal",
    journalArticleDescription: "artikel jurnal ilmiah yang ditinjau sejawat",

    youtubeVideoName: "Video YouTube",
    youtubeVideoTitle: "video YouTube",
    youtubeVideoPhrase: "video YouTube",
    youtubeVideoNoun: "video YouTube",
    youtubeVideoDescription: "video YouTube dan video daring lainnya",

    podcastName: "Podcast",
    podcastTitle: "podcast",
    podcastPhrase: "podcast",
    podcastNoun: "podcast",
    podcastDescription: "episode dan seri podcast",

    newspaperArticleName: "Artikel surat kabar",
    newspaperArticleTitle: "artikel surat kabar",
    newspaperArticlePhrase: "artikel surat kabar",
    newspaperArticleNoun: "artikel surat kabar",
    newspaperArticleDescription: "artikel surat kabar cetak dan daring",

    magazineArticleName: "Artikel majalah",
    magazineArticleTitle: "artikel majalah",
    magazineArticlePhrase: "artikel majalah",
    magazineArticleNoun: "artikel majalah",
    magazineArticleDescription: "artikel majalah cetak dan daring",

    blogPostName: "Tulisan blog",
    blogPostTitle: "tulisan blog",
    blogPostPhrase: "tulisan blog",
    blogPostNoun: "tulisan blog",
    blogPostDescription: "tulisan blog dan artikel opini daring",

    wikipediaName: "Wikipedia",
    wikipediaTitle: "Wikipedia",
    wikipediaPhrase: "Wikipedia",
    wikipediaNoun: "artikel Wikipedia",
    wikipediaDescription: "artikel Wikipedia dan entri wiki",

    pdfName: "PDF",
    pdfTitle: "PDF",
    pdfPhrase: "PDF",
    pdfNoun: "dokumen PDF",
    pdfDescription: "dokumen dan laporan PDF",

    interviewName: "Wawancara",
    interviewTitle: "wawancara",
    interviewPhrase: "wawancara",
    interviewNoun: "wawancara",
    interviewDescription:
      "wawancara pribadi, wawancara terbitan, dan wawancara siaran",

    socialMediaName: "Unggahan media sosial",
    socialMediaTitle: "unggahan media sosial",
    socialMediaPhrase: "unggahan media sosial",
    socialMediaNoun: "unggahan media sosial",
    socialMediaDescription:
      "tweet, unggahan Instagram, unggahan Facebook, dan TikTok",

    governmentDocumentName: "Dokumen pemerintah",
    governmentDocumentTitle: "dokumen pemerintah",
    governmentDocumentPhrase: "dokumen pemerintah",
    governmentDocumentNoun: "dokumen pemerintah",
    governmentDocumentDescription:
      "laporan pemerintah, peraturan perundang-undangan, dan dokumen resmi",

    dissertationName: "Disertasi atau tesis",
    dissertationTitle: "disertasi atau tesis",
    dissertationPhrase: "disertasi atau tesis",
    dissertationNoun: "disertasi atau tesis",
    dissertationDescription: "disertasi doktoral dan tesis magister",

    conferencePaperName: "Makalah konferensi",
    conferencePaperTitle: "makalah konferensi",
    conferencePaperPhrase: "makalah konferensi",
    conferencePaperNoun: "makalah konferensi",
    conferencePaperDescription: "prosiding dan presentasi konferensi",

    lectureNotesName: "Materi kuliah atau PowerPoint",
    lectureNotesTitle: "materi kuliah atau PowerPoint",
    lectureNotesPhrase: "materi kuliah atau PowerPoint",
    lectureNotesNoun: "materi kuliah atau PowerPoint",
    lectureNotesDescription: "materi kuliah, slide, dan bahan ajar",

    webinarName: "Webinar",
    webinarTitle: "webinar",
    webinarPhrase: "webinar",
    webinarNoun: "webinar",
    webinarDescription:
      "webinar dan seminar web yang disiarkan langsung maupun direkam",

    onlineCourseName: "Kursus daring",
    onlineCourseTitle: "kursus daring",
    onlineCoursePhrase: "kursus daring",
    onlineCourseNoun: "kursus daring",
    onlineCourseDescription:
      "kursus daring dan MOOC (Coursera, edX, Udemy, FutureLearn)",

    presentationSlidesName: "Presentasi PowerPoint",
    presentationSlidesTitle: "presentasi PowerPoint",
    presentationSlidesPhrase: "presentasi PowerPoint",
    presentationSlidesNoun: "presentasi PowerPoint",
    presentationSlidesDescription: "PowerPoint dan slide presentasi",

    imageName: "Gambar atau foto",
    imageTitle: "gambar atau foto",
    imagePhrase: "gambar atau foto",
    imageNoun: "gambar atau foto",
    imageDescription: "foto, karya seni, bagan, dan gambar daring",

    movieName: "Film",
    movieTitle: "film",
    moviePhrase: "film",
    movieNoun: "film",
    movieDescription: "film bioskop dan film lainnya",

    documentaryName: "Film dokumenter",
    documentaryTitle: "film dokumenter",
    documentaryPhrase: "film dokumenter",
    documentaryNoun: "film dokumenter",
    documentaryDescription: "film dokumenter dan film nonfiksi",

    tvShowName: "Acara TV",
    tvShowTitle: "acara TV",
    tvShowPhrase: "acara TV",
    tvShowNoun: "acara TV",
    tvShowDescription: "acara TV atau serial televisi",

    songName: "Lagu atau musik",
    songTitle: "lagu atau musik",
    songPhrase: "lagu atau musik",
    songNoun: "lagu atau musik",
    songDescription: "lagu atau rekaman musik",

    poemName: "Puisi",
    poemTitle: "puisi",
    poemPhrase: "puisi",
    poemNoun: "puisi",
    poemDescription: "puisi, sajak, dan syair dari antologi atau kumpulan",

    courtCaseName: "Kasus pengadilan",
    courtCaseTitle: "kasus pengadilan",
    courtCasePhrase: "kasus pengadilan",
    courtCaseNoun: "kasus pengadilan",
    courtCaseDescription: "kasus pengadilan atau putusan hukum",

    patentName: "Paten",
    patentTitle: "paten",
    patentPhrase: "paten",
    patentNoun: "paten",
    patentDescription: "paten atau pengajuan kekayaan intelektual",

    encyclopediaName: "Entri ensiklopedia",
    encyclopediaTitle: "entri ensiklopedia",
    encyclopediaPhrase: "entri ensiklopedia",
    encyclopediaNoun: "entri ensiklopedia",
    encyclopediaDescription: "artikel atau entri ensiklopedia",

    dictionaryName: "Entri kamus",
    dictionaryTitle: "entri kamus",
    dictionaryPhrase: "entri kamus",
    dictionaryNoun: "entri kamus",
    dictionaryDescription: "definisi atau entri kamus",

    datasetName: "Set data",
    datasetTitle: "set data",
    datasetPhrase: "set data",
    datasetNoun: "set data",
    datasetDescription: "set data atau basis data",

    softwareName: "Perangkat lunak atau aplikasi",
    softwareTitle: "perangkat lunak atau aplikasi",
    softwarePhrase: "perangkat lunak atau aplikasi",
    softwareNoun: "perangkat lunak atau aplikasi",
    softwareDescription: "perangkat lunak, aplikasi, atau program komputer",

    videoGameName: "Gim video",
    videoGameTitle: "gim video",
    videoGamePhrase: "gim video",
    videoGameNoun: "gim video",
    videoGameDescription: "gim video dan perangkat lunak gim interaktif",

    pressReleaseName: "Siaran pers",
    pressReleaseTitle: "siaran pers",
    pressReleasePhrase: "siaran pers",
    pressReleaseNoun: "siaran pers",
    pressReleaseDescription: "siaran pers atau rilis berita",

    reportName: "Laporan",
    reportTitle: "laporan",
    reportPhrase: "laporan",
    reportNoun: "laporan",
    reportDescription: "laporan atau white paper",

    preprintName: "Preprint",
    preprintTitle: "preprint",
    preprintPhrase: "preprint",
    preprintNoun: "preprint",
    preprintDescription:
      "makalah dari arXiv, bioRxiv, dan server preprint lainnya",

    bookChapterName: "Bab buku",
    bookChapterTitle: "bab buku",
    bookChapterPhrase: "bab buku",
    bookChapterNoun: "bab buku",
    bookChapterDescription: "bab dan esai dalam buku suntingan",

    chatgptName: "ChatGPT",
    chatgptTitle: "ChatGPT",
    chatgptPhrase: "ChatGPT",
    chatgptNoun: "percakapan ChatGPT",
    chatgptDescription: "ChatGPT dan alat AI generatif lainnya",

    bibleName: "Alkitab",
    bibleTitle: "Alkitab",
    biblePhrase: "Alkitab",
    bibleNoun: "Alkitab",
    bibleDescription: "Alkitab, kitab suci, dan teks sakral lainnya",

    tedTalkName: "TED Talk",
    tedTalkTitle: "TED Talk",
    tedTalkPhrase: "TED Talk",
    tedTalkNoun: "TED Talk",
    tedTalkDescription: "TED Talk dan ceramah konferensi yang direkam",

    emailName: "Email",
    emailTitle: "email",
    emailPhrase: "email",
    emailNoun: "email",
    emailDescription: "email, surat, dan komunikasi pribadi",

    redditName: "Postingan Reddit atau forum",
    redditTitle: "postingan Reddit atau forum",
    redditPhrase: "postingan Reddit",
    redditNoun: "postingan Reddit",
    redditDescription:
      "utas Reddit, AMA, dan postingan forum atau papan diskusi daring",

    tweetName: "Postingan X (Twitter)",
    tweetTitle: "postingan X (Twitter)",
    tweetPhrase: "postingan X",
    tweetNoun: "postingan X",
    tweetDescription: "tweet dan postingan di X (sebelumnya Twitter)",

    mapName: "Peta",
    mapTitle: "peta",
    mapPhrase: "peta",
    mapNoun: "peta",
    mapDescription: "peta cetak, atlas, dan peta dinamis seperti Google Maps",

    claudeName: "Claude",
    claudeTitle: "Claude",
    claudePhrase: "Claude",
    claudeNoun: "percakapan Claude",
    claudeDescription: "percakapan Claude dan keluaran AI Anthropic lainnya",

    geminiName: "Gemini",
    geminiTitle: "Gemini",
    geminiPhrase: "Gemini",
    geminiNoun: "percakapan Gemini",
    geminiDescription: "percakapan dan keluaran AI Google Gemini",

    copilotName: "Microsoft Copilot",
    copilotTitle: "Microsoft Copilot",
    copilotPhrase: "Microsoft Copilot",
    copilotNoun: "percakapan Microsoft Copilot",
    copilotDescription: "percakapan dan jawaban AI Microsoft Copilot",

    perplexityName: "Perplexity",
    perplexityTitle: "Perplexity",
    perplexityPhrase: "Perplexity",
    perplexityNoun: "jawaban Perplexity",
    perplexityDescription:
      "jawaban AI, utas, dan sumber yang dikutip Perplexity",

    aiImageName: "Gambar buatan AI",
    aiImageTitle: "gambar buatan AI",
    aiImagePhrase: "gambar buatan AI",
    aiImageNoun: "gambar buatan AI",
    aiImageDescription:
      "gambar yang dibuat dengan DALL·E, Midjourney, Gemini, dan alat AI lainnya",

    tiktokName: "Video TikTok",
    tiktokTitle: "video TikTok",
    tiktokPhrase: "video TikTok",
    tiktokNoun: "video TikTok",
    tiktokDescription: "video TikTok dan postingan kreator",

    instagramName: "Postingan Instagram",
    instagramTitle: "postingan Instagram",
    instagramPhrase: "postingan Instagram",
    instagramNoun: "postingan Instagram",
    instagramDescription: "postingan, reel, dan story Instagram",

    statuteName: "Undang-undang atau peraturan",
    statuteTitle: "undang-undang atau peraturan",
    statutePhrase: "undang-undang atau peraturan",
    statuteNoun: "undang-undang atau peraturan",
    statuteDescription:
      "undang-undang dari lembaga legislatif, peraturan perundang-undangan, dan hukum yang dikodifikasi",

    isoStandardName: "Standar ISO",
    isoStandardTitle: "standar ISO",
    isoStandardPhrase: "standar ISO",
    isoStandardNoun: "standar ISO",
    isoStandardDescription:
      "standar ISO, IEC, dan standar teknis terbitan lainnya",

    quranName: "Al-Qur'an",
    quranTitle: "Al-Qur'an",
    quranPhrase: "Al-Qur'an",
    quranNoun: "Al-Qur'an",
    quranDescription: "Al-Qur'an, dalam bahasa Arab maupun terjemahan",

    ebookNoPageNumbersName: "Buku elektronik tanpa nomor halaman",
    ebookNoPageNumbersTitle: "buku elektronik tanpa nomor halaman",
    ebookNoPageNumbersPhrase: "buku elektronik tanpa nomor halaman",
    ebookNoPageNumbersNoun: "buku elektronik tanpa nomor halaman",
    ebookNoPageNumbersDescription:
      "buku elektronik Kindle, EPUB, dan daring yang tidak memiliki nomor halaman tetap",

    speechName: "Pidato",
    speechTitle: "pidato",
    speechPhrase: "pidato",
    speechNoun: "pidato",
    speechDescription:
      "pidato, sambutan, dan khotbah, baik langsung maupun rekaman",

    letterName: "Surat",
    letterTitle: "surat",
    letterPhrase: "surat",
    letterNoun: "surat",
    letterDescription:
      "surat yang diterbitkan, surat dalam arsip, dan surat terbuka",

    secondarySourceName: "Sumber sekunder",
    secondarySourceTitle: "sumber sekunder",
    secondarySourcePhrase: "sumber sekunder",
    secondarySourceNoun: "sumber sekunder",
    secondarySourceDescription:
      "sumber yang Anda temukan dikutip atau disitasi dalam karya lain",
  },

  // ---------------------------------------------------------------------------
  // NOT YET TRANSLATED. These five sections were copied verbatim from `en.ts` so
  // this file still satisfies `Dictionary`; the page types they cover
  // (`taxonomy`, `compare`, `convert`) are deliberately absent from
  // TRANSLATED_PAGE_TYPES, so nothing publishes them in this language yet. The
  // translation pass replaces the strings and only then adds the types.
  // ---------------------------------------------------------------------------
  // The three browse-by-facet pages under `/<locale>/citation-styles/…` — 32 academic
  // fields, 68 countries and 39 subject categories, 139 pages in one section because
  // they share a shell, a breadcrumb trail and a styles browser.
  //
  // The style NAMES, slugs and the CSL catalog itself stay in `src/data/**`: those are
  // subject matter. What the facets themselves are called is not — "Political Science",
  // "United Kingdom" and "Film & Media" are ordinary nouns that every reader expects in
  // their own language, and there are only 139 of them in total (see the `academicFields`,
  // `regions` and `styleCategories` sections below).
  taxonomyPage: {
    // ---- /citation-styles/field/<slug> ----
    fieldNotFoundTitle: "Tidak Ditemukan",
    fieldMetaTitle: "Gaya Sitasi untuk {field} - Gaya Referensi Terbaik [2026]",
    fieldMetaDescription:
      "Temukan gaya sitasi yang paling umum digunakan dalam {field}. Cari format referensi yang tepat untuk makalah, tesis, atau naskah jurnal {fieldLower} Anda.",
    fieldOgTitle: "Gaya sitasi untuk {field}",
    fieldOgSubtitle: "Umumnya diwajibkan: {styles}.",
    fieldOgKind: "Berdasarkan bidang akademik",
    fieldKeywordStyle: "gaya sitasi {field}",
    fieldKeywordReferencing: "referensi {field}",
    fieldKeywordBest: "gaya sitasi terbaik untuk {fieldLower}",
    fieldKeywordBibliography: "format daftar pustaka {fieldLower}",
    fieldKeywordDiscipline: "gaya sitasi berdasarkan disiplin ilmu",
    fieldBackLink: "← Semua Gaya Sitasi",
    fieldHeading: "Gaya Sitasi untuk {field}",
    fieldRecommendedHeading: "Gaya Sitasi yang Direkomendasikan",
    fieldRecommendedIntro:
      "Gaya sitasi berikut umum digunakan dalam penelitian, jurnal, dan tugas kuliah bidang {field}. Pilih satu gaya untuk mempelajarinya lebih lanjut dan mulai membuat sitasi.",
    fieldStyleFallback:
      "Gaya sitasi yang digunakan dalam bidang {field} dan disiplin terkait.",
    fieldRelatedHeading: "Bidang Terkait",
    fieldRelatedIntro:
      "Jelajahi gaya sitasi yang digunakan dalam disiplin akademik terkait:",
    fieldCtaHeading: "Jelajahi Semua Gaya Sitasi",
    fieldCtaBody:
      "CitationEasy mendukung {count} gaya sitasi di semua disiplin akademik. Jelajahi koleksi lengkapnya untuk menemukan format yang tepat sesuai kebutuhan Anda.",
    fieldCtaButton: "Jelajahi Semua Gaya →",
    fieldFaqWhichQ: "Gaya sitasi apa yang digunakan dalam {field}?",
    fieldFaqWhichA:
      "Gaya sitasi yang digunakan dalam {field} bergantung pada jurnal, institusi, atau ketentuan dosen tertentu. Gaya yang umum digunakan antara lain {styles}. Selalu periksa pedoman tugas atau jurnal tujuan Anda untuk mengetahui format yang diwajibkan.",
    fieldFaqSameQ: "Apakah semua jurnal {field} menggunakan gaya yang sama?",
    fieldFaqSameA:
      "Tidak, tidak semua jurnal {field} menggunakan gaya sitasi yang sama. Meskipun gaya tertentu lebih umum digunakan di bidang ini, setiap jurnal bisa saja memiliki ketentuan format sendiri. Selalu periksa pedoman pengiriman naskah jurnal sebelum menyiapkan tulisan Anda.",
    fieldFaqChooseQ:
      "Bagaimana cara memilih gaya sitasi untuk makalah {field} saya?",
    fieldFaqChooseA:
      "Untuk memilih gaya sitasi bagi makalah {field} Anda, pertama periksa apakah dosen atau jurnal tujuan Anda menetapkan gaya tertentu. Jika tidak, gunakan salah satu gaya yang direkomendasikan untuk {field} pada daftar di atas. CitationEasy mendukung lebih dari {count} gaya dan dapat membuat sitasi dalam gaya apa pun secara gratis.",

    // ---- /citation-styles/country/<slug> ----
    countryNotFoundTitle: "Negara tidak ditemukan",
    countryMetaTitle: "Gaya sitasi {country} - APA, MLA & lainnya",
    countryMetaDescription:
      "Jelajahi gaya sitasi yang digunakan di {country}. Pembuat sitasi gratis untuk format {country}.",
    countryOgTitle: "Gaya sitasi yang digunakan di {country}",
    countryOgKind: "Berdasarkan negara",
    countryHeading: "Gaya sitasi {country}",
    countryIntroOne:
      "{count} gaya sitasi yang umum digunakan di atau terkait dengan {country}. Pilih salah satu untuk membuka pembuat sitasi khusus.",
    countryIntroMany:
      "{count} gaya sitasi yang umum digunakan di atau terkait dengan {country}. Pilih salah satu untuk membuka pembuat sitasi khusus.",
    countryBrowserTitle: "Gaya Sitasi {country}",

    // ---- /citation-styles/type/<slug> ----
    typeNotFoundTitle: "Jenis tidak ditemukan",
    typeMetaTitle: "Gaya sitasi {type} - Pembuat sitasi gratis",
    typeMetaDescription:
      "Gaya sitasi untuk {typeLower}. APA, MLA, Vancouver, dan lainnya. Pembuat sitasi gratis.",
    typeOgTitle: "Gaya sitasi {type}",
    typeOgKind: "Berdasarkan bidang studi",
    typeHeading: "Gaya sitasi {type}",
    typeIntroOne:
      "{count} gaya sitasi untuk {typeLower}. Pilih salah satu untuk membuka pembuat sitasi khusus lengkap dengan tanya jawab.",
    typeIntroMany:
      "{count} gaya sitasi untuk {typeLower}. Pilih salah satu untuk membuka pembuat sitasi khusus lengkap dengan tanya jawab.",
    typeBrowserTitle: "Gaya Sitasi {type}",

    // ---- Shared chrome ----
    breadcrumbStyles: "Gaya sitasi",
    // Title case, because the BreadcrumbList markup says "Citation Styles" while the
    // visible trail says "Citation styles". Two keys rather than one so translating
    // either does not silently change the other.
    breadcrumbStylesSchema: "Gaya Sitasi",
    breadcrumbByCountry: "Berdasarkan negara",
    breadcrumbByDiscipline: "Berdasarkan disiplin ilmu",
    allStylesLink: "← Semua gaya sitasi",
    internationalLabel: "Internasional",
  },

  // The 32 academic fields (`ACADEMIC_FIELDS` in src/data/style-pages.ts), keyed by
  // slug. Their one-sentence `description` is next door in `academicFieldDescriptions`.
  academicFields: {
    psychology: "Psikologi",
    education: "Pendidikan",
    sociology: "Sosiologi",
    anthropology: "Antropologi",
    politicalScience: "Ilmu Politik",
    economics: "Ekonomi",
    business: "Bisnis & Manajemen",
    literature: "Sastra & Bahasa",
    history: "Sejarah",
    philosophy: "Filsafat",
    law: "Hukum & Ilmu Hukum",
    medicine: "Kedokteran & Ilmu Klinis",
    nursing: "Keperawatan & Kebidanan",
    publicHealth: "Kesehatan Masyarakat & Epidemiologi",
    pharmacy: "Farmasi",
    biology: "Biologi & Ilmu Hayati",
    chemistry: "Kimia",
    physics: "Fisika",
    engineering: "Teknik",
    computerScience: "Ilmu Komputer",
    mathematics: "Matematika & Statistika",
    environmentalScience: "Ilmu Lingkungan",
    earthScience: "Ilmu Bumi & Geologi",
    artHistory: "Sejarah Seni & Seni Rupa",
    music: "Musik & Musikologi",
    theology: "Teologi & Studi Agama",
    socialWork: "Pekerjaan Sosial",
    linguistics: "Linguistik",
    architecture: "Arsitektur & Perencanaan Kota",
    filmMedia: "Film & Studi Media",
    journalism: "Jurnalistik & Komunikasi",
    criminology: "Kriminologi & Peradilan Pidana",
  },

  // The same 32 fields' one-sentence ledes — the opening paragraph of every
  // `/citation-styles/field/<slug>` page.
  //
  // Unlike everything above, these are hand-written per field rather than mail-merged
  // from a template, which is why the extraction pass left them in
  // `src/data/style-pages.ts`: translating them is a content job, not a string swap.
  // But "hand-written" describes how they were produced, not where they belong. With
  // the chrome translated and the lede still English, the page is the hybrid CLAUDE.md
  // calls worse than an honest redirect — translated furniture around an English core.
  // `academicFieldDescription()` (src/lib/i18n/data-labels.ts) falls back to the data
  // file's own value, so a field added upstream is untranslated rather than blank.
  academicFieldDescriptions: {
    psychology:
      "Gaya sitasi yang umum digunakan dalam psikologi, ilmu perilaku, dan penelitian kognitif.",
    education:
      "Gaya sitasi untuk penelitian pendidikan, pedagogi, dan studi kurikulum.",
    sociology:
      "Gaya sitasi yang digunakan dalam penelitian sosiologi dan teori sosial.",
    anthropology: "Gaya sitasi untuk penelitian antropologi dan etnografi.",
    politicalScience:
      "Gaya sitasi untuk penelitian ilmu politik, pemerintahan, dan kebijakan publik.",
    economics:
      "Gaya sitasi yang digunakan dalam penelitian ekonomi dan ekonometrika.",
    business:
      "Gaya sitasi untuk penelitian bisnis, manajemen, pemasaran, dan keuangan.",
    literature:
      "Gaya sitasi untuk kajian sastra, linguistik, dan penelitian bahasa.",
    history:
      "Gaya sitasi untuk penelitian sejarah, historiografi, dan kajian arsip.",
    philosophy: "Gaya sitasi untuk tulisan filsafat dan penelitian etika.",
    law: "Gaya sitasi hukum untuk dokumen pengadilan, jurnal hukum, dan karya ilmiah hukum.",
    medicine:
      "Gaya sitasi untuk penelitian medis, studi klinis, dan layanan kesehatan.",
    nursing:
      "Gaya sitasi untuk penelitian keperawatan dan praktik layanan kesehatan.",
    publicHealth:
      "Gaya sitasi untuk penelitian kesehatan masyarakat dan studi epidemiologi.",
    pharmacy: "Gaya sitasi untuk penelitian farmasi dan farmakologi.",
    biology: "Gaya sitasi untuk penelitian biologi, ekologi, dan genetika.",
    chemistry:
      "Gaya sitasi untuk penelitian kimia, biokimia, dan ilmu material.",
    physics:
      "Gaya sitasi untuk penelitian fisika, astrofisika, dan fisika terapan.",
    engineering: "Gaya sitasi untuk penelitian teknik dan teknologi terapan.",
    computerScience:
      "Gaya sitasi untuk penelitian ilmu komputer, AI, dan rekayasa perangkat lunak.",
    mathematics:
      "Gaya sitasi untuk penelitian matematika, matematika terapan, dan statistika.",
    environmentalScience:
      "Gaya sitasi untuk penelitian lingkungan dan studi keberlanjutan.",
    earthScience:
      "Gaya sitasi untuk penelitian geologi, geofisika, dan ilmu kebumian.",
    artHistory:
      "Gaya sitasi untuk sejarah seni, kajian budaya visual, dan studi permuseuman.",
    music:
      "Gaya sitasi untuk penelitian musik, teori musik, dan studi pertunjukan.",
    theology: "Gaya sitasi untuk karya ilmiah teologi dan keagamaan.",
    socialWork: "Gaya sitasi untuk penelitian dan praktik pekerjaan sosial.",
    linguistics: "Gaya sitasi untuk linguistik, fonetik, dan ilmu bahasa.",
    architecture:
      "Gaya sitasi untuk penelitian arsitektur, desain kota, dan perencanaan wilayah.",
    filmMedia:
      "Gaya sitasi untuk kajian film, televisi, media, dan komunikasi.",
    journalism:
      "Gaya sitasi untuk penelitian jurnalistik, kajian media, dan komunikasi.",
    criminology:
      "Gaya sitasi untuk penelitian kriminologi dan peradilan pidana.",
  },

  // The 68 country/region facets (`REGIONS` in src/data/citation-styles.ts), keyed by
  // slug. `getRegionCountryCode` still keys off the English data value, so translating these
  // moves the label without moving the flag.
  regions: {
    unitedStates: "Amerika Serikat",
    unitedKingdom: "Britania Raya",
    australia: "Australia",
    canada: "Kanada",
    newZealand: "Selandia Baru",
    ireland: "Irlandia",
    southAfrica: "Afrika Selatan",
    germany: "Jerman",
    france: "Prancis",
    spain: "Spanyol",
    italy: "Italia",
    netherlands: "Belanda",
    belgium: "Belgia",
    switzerland: "Swiss",
    austria: "Austria",
    portugal: "Portugal",
    luxembourg: "Luksemburg",
    sweden: "Swedia",
    norway: "Norwegia",
    denmark: "Denmark",
    finland: "Finlandia",
    iceland: "Islandia",
    poland: "Polandia",
    czechRepublic: "Republik Ceko",
    hungary: "Hongaria",
    romania: "Rumania",
    russia: "Rusia",
    ukraine: "Ukraina",
    greece: "Yunani",
    turkey: "Turki",
    croatia: "Kroasia",
    slovenia: "Slovenia",
    slovakia: "Slowakia",
    serbia: "Serbia",
    bulgaria: "Bulgaria",
    lithuania: "Lituania",
    latvia: "Latvia",
    estonia: "Estonia",
    japan: "Jepang",
    china: "Tiongkok",
    southKorea: "Korea Selatan",
    india: "India",
    singapore: "Singapura",
    hongKong: "Hong Kong",
    taiwan: "Taiwan",
    malaysia: "Malaysia",
    indonesia: "Indonesia",
    thailand: "Thailand",
    vietnam: "Vietnam",
    philippines: "Filipina",
    pakistan: "Pakistan",
    bangladesh: "Bangladesh",
    sriLanka: "Sri Lanka",
    israel: "Israel",
    saudiArabia: "Arab Saudi",
    unitedArabEmirates: "Uni Emirat Arab",
    brazil: "Brasil",
    mexico: "Meksiko",
    argentina: "Argentina",
    chile: "Chili",
    colombia: "Kolombia",
    peru: "Peru",
    venezuela: "Venezuela",
    egypt: "Mesir",
    nigeria: "Nigeria",
    kenya: "Kenya",
    morocco: "Maroko",
    international: "Internasional",
  },

  // The 39 subject categories (`CATEGORIES` in src/data/citation-styles.ts), keyed by
  // slug. The emoji beside each one stays in the data — it is language-neutral.
  styleCategories: {
    medicine: "Kedokteran",
    nursing: "Keperawatan",
    publicHealth: "Kesehatan Masyarakat",
    pharmacy: "Farmasi",
    dentistry: "Kedokteran Gigi",
    veterinary: "Ilmu Kedokteran Hewan",
    psychology: "Psikologi",
    sociology: "Sosiologi",
    anthropology: "Antropologi",
    politicalScience: "Ilmu Politik",
    economics: "Ekonomi",
    education: "Pendidikan",
    socialWork: "Pekerjaan Sosial",
    biology: "Biologi",
    chemistry: "Kimia",
    physics: "Fisika",
    environmentalScience: "Ilmu Lingkungan",
    earthScience: "Ilmu Bumi & Geologi",
    agriculture: "Pertanian",
    ecology: "Ekologi",
    engineering: "Teknik",
    computerScience: "Ilmu Komputer",
    mathematics: "Matematika",
    statistics: "Statistika",
    history: "Sejarah",
    literature: "Sastra",
    philosophy: "Filsafat",
    linguistics: "Linguistik",
    artHistory: "Sejarah Seni",
    music: "Musik",
    filmMedia: "Film & Media",
    archaeology: "Arkeologi",
    law: "Hukum",
    business: "Bisnis",
    architecture: "Arsitektur",
    religion: "Agama & Teologi",
    geography: "Geografi",
    general: "Umum / Multidisiplin",
    other: "Lainnya",
  },

  // The closed vocabularies `STYLE_LANDING_PAGES` (src/data/style-pages.ts) draws on for
  // the 30 major styles: what each style calls its end-of-paper list, the shape of its
  // in-text citation, its edition, and the disciplines that require it. The comparison
  // pages print all four in a table and the field pages print two of them under every
  // style card, so leaving them in the data means a translated page with an English
  // table in the middle of it.
  //
  // Style NAMES (`name`, `fullName`) are NOT here: a style's official name is what it
  // is called everywhere. The 30 hand-written taglines are, in `styleTaglines` below.
  styleFacts: {
    // `referenceListName` — 6 distinct values across the 30 styles.
    listReferenceList: "Daftar Referensi",
    listWorksCited: "Daftar Karya yang Dikutip",
    listReferences: "Referensi",
    listBibliography: "Daftar Pustaka",
    listTableOfAuthorities: "Daftar Sumber Hukum",
    listReferencesCited: "Referensi yang Dikutip",
    listLowerReferenceList: "daftar referensi",
    listLowerWorksCited: "daftar karya yang dikutip",
    listLowerReferences: "referensi",
    listLowerBibliography: "daftar pustaka",
    listLowerTableOfAuthorities: "daftar sumber hukum",
    listLowerReferencesCited: "referensi yang dikutip",

    // `inTextFormat` — 14 distinct values. "Author", "Year" and "Page" are slot names,
    // not part of the citation, so they read as English words on a Spanish page.
    inTextAuthorCommaYear: "(Penulis, Tahun)",
    inTextAuthorPage: "(Penulis Halaman)",
    inTextAuthorYear: "(Penulis Tahun)",
    inTextSuperscriptOrBracketed:
      "Angka superskrip atau dalam tanda kurung (1)",
    inTextBracketedNumbers: "Angka dalam tanda kurung siku [1]",
    inTextSuperscriptNumbers: "Angka superskrip¹",
    inTextSuperscriptOrAuthorYear: "Angka superskrip atau (Penulis Tahun)",
    inTextKeyBased: "Referensi berbasis kunci",
    inTextSuperscriptOrAuthorCommaYear:
      "Angka superskrip atau (Penulis, Tahun)",
    inTextFootnotesCaseLegislation:
      "Catatan kaki dengan sitasi putusan pengadilan dan perundang-undangan",
    inTextFootnotesSignals: "Catatan kaki dengan singkatan sinyal",
    inTextFootnotesPinpoint: "Catatan kaki dengan rujukan halaman spesifik",
    inTextParenNumbers: "Angka dalam tanda kurung (1)",
    inTextItalicNumbers: "Angka miring (1)",

    // `edition` — 12 distinct values. The ordinal and the word "edition" translate; the
    // handbook name inside "Cite Them Right 11th edition" does not.
    edition4th: "Edisi ke-4",
    edition5th: "Edisi ke-5",
    edition7th: "Edisi ke-7",
    edition8th: "Edisi ke-8",
    edition9th: "Edisi ke-9",
    edition11th: "Edisi ke-11",
    edition18th: "Edisi ke-18",
    edition22nd: "Edisi ke-22",
    editionCiteThemRight11th: "Cite Them Right edisi ke-11",
    editionIcmjeStandard: "standar ICMJE",
    editionStandard: "standar",
    editionCurrent: "terkini",

    // `fields` — the 67 discipline names the 30 styles are tagged with.
    fieldAcoustics: "Akustik",
    fieldAnthropology: "Antropologi",
    fieldAppliedPhysics: "Fisika Terapan",
    fieldArchaeology: "Arkeologi",
    fieldArts: "Seni",
    fieldAstrophysics: "Astrofisika",
    fieldAustralianLaw: "Hukum Australia",
    fieldBiochemistry: "Biokimia",
    fieldBiology: "Biologi",
    fieldBiomedicalSciences: "Ilmu Biomedis",
    fieldBiotechnology: "Bioteknologi",
    fieldBusiness: "Bisnis",
    fieldCellBiology: "Biologi Sel",
    fieldChemicalEngineering: "Teknik Kimia",
    fieldChemistry: "Kimia",
    fieldClinicalResearch: "Penelitian Klinis",
    fieldComputerScience: "Ilmu Komputer",
    fieldCondensedMatter: "Fisika Materi Terkondensasi",
    fieldCourtDocuments: "Dokumen Pengadilan",
    fieldCriminology: "Kriminologi",
    fieldCulturalStudies: "Kajian Budaya",
    fieldDemography: "Demografi",
    fieldEcology: "Ekologi",
    fieldEducation: "Pendidikan",
    fieldElectronics: "Elektronika",
    fieldEngineering: "Teknik",
    fieldEnvironmentalScience: "Ilmu Lingkungan",
    fieldEpidemiology: "Epidemiologi",
    fieldEthnography: "Etnografi",
    fieldGenetics: "Genetika",
    fieldGeology: "Geologi",
    fieldGlobalHealth: "Kesehatan Global",
    fieldHealthSciences: "Ilmu Kesehatan",
    fieldHistory: "Sejarah",
    fieldHumanities: "Humaniora",
    fieldInformationSystems: "Sistem Informasi",
    fieldInformationTechnology: "Teknologi Informasi",
    fieldInternationalRelations: "Hubungan Internasional",
    fieldJurisprudence: "Ilmu Hukum",
    fieldLanguages: "Bahasa",
    fieldLaw: "Hukum",
    fieldLawReview: "Jurnal Hukum",
    fieldLegalStudies: "Kajian Hukum",
    fieldLifeSciences: "Ilmu Hayati",
    fieldLiterature: "Sastra",
    fieldMaterialsScience: "Ilmu Material",
    fieldMathematics: "Matematika",
    fieldMedicine: "Kedokteran",
    fieldMolecularBiology: "Biologi Molekuler",
    fieldMultidisciplinary: "Multidisiplin",
    fieldMultidisciplinaryScience: "Sains Multidisiplin",
    fieldNaturalSciences: "Ilmu Alam",
    fieldNursing: "Keperawatan",
    fieldPharmacy: "Farmasi",
    fieldPhysics: "Fisika",
    fieldPoliticalScience: "Ilmu Politik",
    fieldPsychology: "Psikologi",
    fieldPublicHealth: "Kesehatan Masyarakat",
    fieldPublicPolicy: "Kebijakan Publik",
    fieldPublishing: "Penerbitan",
    fieldScience: "Sains",
    fieldSciences: "Ilmu Pengetahuan",
    fieldSocialSciences: "Ilmu Sosial",
    fieldSocialWork: "Pekerjaan Sosial",
    fieldSociology: "Sosiologi",
    fieldSoftwareEngineering: "Rekayasa Perangkat Lunak",
    fieldTheology: "Teologi",
  },

  // The 30 major styles' hero taglines (`STYLE_LANDING_PAGES[].tagline`), keyed by
  // slug.
  //
  // Per-page hand-written copy, not a template — which is why they outlived the
  // extraction pass in `src/data/style-pages.ts`. Three page types print them: the
  // style landing page's hero, the card for each recommended style on a field
  // taxonomy page, and the lower-cased clause inside a comparison page's opening
  // sentence ("APA (…) is the most widely used citation style in the social
  // sciences"). Leaving them in the data means an English sentence in the first
  // paragraph of an otherwise translated page. `styleTagline()`
  // (src/lib/i18n/data-labels.ts) falls back to the data file's own value.
  styleTaglines: {
    apa: "Gaya sitasi yang paling banyak digunakan dalam ilmu sosial",
    mla: "Gaya sitasi standar untuk bidang humaniora",
    chicago:
      "Panduan gaya paling tepercaya di Amerika bagi penulis, editor, dan penerbit",
    harvard:
      "Gaya sitasi paling populer di universitas-universitas Inggris dan Australia",
    vancouver: "Gaya sitasi standar untuk jurnal kedokteran dan biomedis",
    ieee: "Gaya sitasi andalan untuk bidang teknik dan ilmu komputer",
    ama: "Standar sitasi untuk jurnal kedokteran Amerika",
    turabian: "Versi Chicago yang lebih ramah untuk mahasiswa",
    cse: "Gaya sitasi pilihan untuk ilmu alam dan ilmu fisika",
    bibtex:
      "Format daftar pustaka untuk pengguna LaTeX dan tata letak akademik",
    nature:
      "Gaya sitasi yang digunakan oleh jurnal multidisiplin terkemuka di dunia",
    acs: "Standar sitasi untuk kimia dan ilmu kimia",
    oscola:
      "Gaya sitasi hukum standar untuk sekolah hukum dan jurnal di Inggris",
    bluebook:
      "Sistem sitasi hukum utama untuk pengadilan dan jurnal hukum di Amerika Serikat",
    aglc: "Gaya sitasi hukum standar untuk sekolah hukum dan pengadilan di Australia",
    asa: "Gaya sitasi standar untuk sosiologi dan penelitian sosial",
    apsa: "Gaya sitasi untuk penelitian dan jurnal ilmu politik",
    aaa: "Gaya sitasi standar untuk penelitian antropologi",
    nlm: "Standar sitasi yang digunakan oleh PubMed dan National Library of Medicine",
    acm: "Gaya sitasi untuk konferensi ACM dan penelitian ilmu komputer",
    aps: "Gaya sitasi untuk Physical Review dan jurnal APS",
    aip: "Gaya sitasi untuk AIP dan jurnal fisika",
    cell: "Gaya sitasi untuk Cell Press dan jurnal biologi terkemuka",
    science: "Gaya sitasi untuk majalah Science dan jurnal AAAS",
    plos: "Gaya sitasi untuk jurnal akses terbuka PLOS",
    bmj: "Gaya sitasi untuk BMJ dan jurnal kedokteran terkemuka di Inggris",
    lancet: "Gaya sitasi untuk keluarga jurnal kedokteran The Lancet",
    jama: "Gaya sitasi untuk JAMA dan jurnal-jurnal JAMA Network",
    elsevierHarvard:
      "Varian gaya Harvard yang digunakan di jurnal-jurnal Elsevier",
    springer: "Gaya sitasi untuk jurnal dan buku Springer Nature",
  },

  // The 105 style-versus-style pages at `/<locale>/compare/<slug>`.
  //
  // The two style names arrive as placeholder values and are never translated. The
  // facts in the table come from `styleFacts` above and the taglines from
  // `styleTaglines`; only `fullName` stays in `src/data/style-pages.ts`, because an
  // official name is the same in every language.
  comparePage: {
    notFoundTitle: "Tidak Ditemukan",
    metaTitle: "{a} vs {b} - Perbedaan Utama Dijelaskan [2026]",
    metaDescription:
      "Bandingkan gaya sitasi {a} dan {b} secara berdampingan. Pelajari perbedaan utama dalam pemformatan, sitasi dalam teks, dan daftar referensi untuk memilih gaya yang tepat bagi makalah Anda.",
    ogTitle: "{a} vs {b}",
    ogSubtitle:
      "Format dalam teks, entri referensi, kapitalisasi, dan disiplin ilmu mana yang mewajibkan masing-masing gaya.",
    ogKind: "Perbandingan gaya",
    keywordVs: "{a} vs {b}",
    keywordVersus: "{a} versus {b}",
    keywordDifference: "perbedaan antara {a} dan {b}",
    keywordOr: "{a} atau {b}",
    keywordComparison: "perbandingan gaya sitasi",
    breadcrumbCompare: "Bandingkan Gaya",
    breadcrumbCurrent: "{a} vs {b}",
    backLink: "← Kembali ke Alat Perbandingan",
    heading: "{a} vs {b}: Perbedaan Utama",
    intro:
      "{a} dan {b} adalah dua gaya sitasi yang paling banyak digunakan di dunia akademik, tetapi keduanya berbeda dalam hal-hal penting. {introA} {introB} Memahami perbedaan ini akan membantu Anda memilih format yang tepat untuk makalah Anda.",
    styleIntro: "{style} ({fullName}) {tagline}.",
    styleIntroFallback:
      "{style} adalah gaya sitasi populer yang digunakan di berbagai disiplin akademik.",
    tableHeading: "Perbandingan Berdampingan",
    tableFeature: "Fitur",
    tableCitationSystem: "Sistem Sitasi",
    tableInText: "Format dalam Teks",
    tableReferenceList: "Nama Daftar Referensi",
    tableEdition: "Edisi",
    tableCommonFields: "Bidang Umum",
    // Title case, for the table cell. `styleLanding.system*` says "Author–date" for the
    // fact list on the style landing pages; both spellings are deliberate.
    systemAuthorDate: "Penulis-Tahun",
    systemNumbered: "Bernomor",
    systemFootnotes: "Catatan Kaki",
    // The same three systems inside a sentence ("uses a numbered citation system").
    describeAuthorDate: "penulis-tahun dalam tanda kurung",
    describeNumbered: "bernomor",
    describeFootnotes: "berbasis catatan kaki",
    whenToUseHeading: "Kapan Menggunakan {style}",
    whenToUseBody:
      "{style} ({fullName}) menggunakan sistem sitasi {system} dengan sitasi dalam teks berformat {inText} dan {list} di akhir tulisan. Gaya ini paling umum digunakan di bidang {fields}{more}.",
    whenToUseMoreFields: ", dan bidang terkait",
    whenToUseFallback:
      "{style} adalah gaya sitasi yang banyak dikenal. Periksa pedoman tugas atau jurnal tujuan Anda untuk memastikan apakah {style} adalah format yang diwajibkan.",
    ctaHeading: "Lihat Perbedaannya Secara Langsung",
    ctaBodyBefore: "Coba",
    ctaBodyLink: "alat perbandingan interaktif kami",
    ctaBodyAfter:
      "untuk membandingkan sitasi {a} dan {b} secara berdampingan menggunakan sumber Anda sendiri.",
    ctaCiteIn: "Sitasi dengan {style} →",
    faqDifferenceQ: "Apa perbedaan antara {a} dan {b}?",
    faqDifferenceA:
      "{a} dan {b} berbeda dalam format sitasi dalam teks, struktur daftar referensi, dan disiplin akademik yang menggunakannya. {detail}",
    faqDifferenceDetail:
      "{a} menggunakan sitasi dalam teks {inTextA} dengan {listA}, sedangkan {b} menggunakan {inTextB} dengan {listB}.",
    faqDifferenceDetailFallback:
      "Setiap gaya memiliki aturan tersendiri untuk memformat sitasi, menyusun daftar pustaka, dan menangani berbagai jenis sumber.",
    faqBetterQ: "Mana yang lebih baik, {a} atau {b}?",
    faqBetterA:
      "{a} maupun {b} tidak ada yang secara inheren lebih baik. Pilihan yang tepat bergantung pada disiplin akademik Anda, ketentuan dosen, atau jurnal yang Anda tuju. Periksa pedoman tugas atau publikasi tujuan Anda untuk menentukan gaya yang harus digunakan.",
    faqSwitchQ: "Bisakah saya beralih antara {a} dan {b}?",
    faqSwitchA:
      "Ya, Anda dapat beralih antara {a} dan {b} menggunakan pembuat sitasi gratis dari CitationEasy. Cukup pilih gaya yang diinginkan, dan sitasi Anda akan diformat ulang secara otomatis. Namun, Anda sebaiknya hanya menggunakan satu gaya per makalah kecuali dosen Anda menyatakan sebaliknya.",
  },

  // The ~21 converter-pair pages at `/<locale>/convert/<slug>`.
  //
  // Only the shell is here; each pair's own four strings are in `converterCopy` below.
  // The format names (DOI, ISBN, BibTeX, RIS, CSL-JSON, PubMed ID, arXiv ID, Word) are
  // identifiers, never translated.
  converterPage: {
    notFoundTitle: "Pengonversi tidak ditemukan",
    metaTitle: "{title} - Gratis & Instan",
    ogTitle: "{title}",
    ogKind: "Pengonversi",
    breadcrumbConverters: "Pengonversi",
    breadcrumbLabel: "Remah navigasi",
    whenHeading: "Kapan Anda memerlukan ini",
    relatedHeading: "Pengonversi terkait",
    allConverters: "Semua pengonversi",
    formatConverterTool: "Pengonversi Format Sitasi",
    faqHowQ: "Bagaimana cara mengonversi {input} ke {output}?",
    faqHowA: "{intro} Semuanya gratis, tanpa akun dan tanpa batas konversi.",
    faqPrivacyQ: "Apakah data saya diunggah ke suatu tempat?",
    faqPrivacyIdentifier:
      "Setiap {input} dicocokkan dengan layanan metadata publik yang relevan (Crossref untuk DOI, PubMed untuk PMID, katalog perpustakaan untuk ISBN), dan hanya pengidentifikasi itu sendiri yang dikirim — dokumen Anda tidak pernah dikirim. Hasil yang sudah diformat sepenuhnya milik Anda untuk disalin atau diunduh; tidak ada yang disimpan.",
    faqPrivacyLocal:
      "Tidak — {input} yang Anda tempel atau unggah sepenuhnya diproses di peramban Anda. {detail}",
    faqPrivacyDetailStyle:
      "Hanya bidang referensi yang telah diuraikan (penulis, judul, tahun) yang dikirim ke pemformat kami untuk membuat sitasi; berkas Anda sendiri tidak pernah meninggalkan perangkat Anda.",
    faqPrivacyDetailOffline:
      "Konversi berjalan sepenuhnya offline di halaman ini — tidak ada yang dikirim ke server mana pun.",
    faqUsefulQ: "Kapan konversi {input} ke {output} berguna?",
    faqOtherQ: "Bisakah saya mengonversi ke gaya dan format lain juga?",
    faqOtherA:
      "Ya. Pembuat sitasi CitationEasy memformat sumber apa pun dalam {count} gaya sitasi, daftar pustaka dapat diekspor ke Word, RTF, BibTeX, RIS, dan CSL-JSON, dan halaman pusat pengonversi mencantumkan setiap pasangan konversi langsung. Jika Anda perlu menulis ulang teks yang sudah diformat dari satu gaya ke gaya lain, gunakan alat Pengonversi Format Sitasi.",
  },

  // The 21 converter pairs' own copy (`CONVERTER_PAIRS` in src/data/converters.ts),
  // keyed by slug: title, meta description, the intro paragraph under the H1, and the
  // "when you need this" paragraph.
  //
  // Four hand-written strings per pair, and `src/data/converters.ts` has a quality rule
  // saying they must stay hand-written — no mail-merged sentences, because mass-templated
  // pages are what earned the site a scaled-content penalty. That rule is about how the
  // copy is authored; it says nothing about which language a reader gets it in. Left in
  // the data file they are the entire body of an otherwise translated page.
  // `converterPairCopy()` (src/lib/i18n/data-labels.ts) returns all four at once and
  // falls back to the data file per field, so a converter added upstream ships English
  // copy rather than a blank page.
  converterCopy: {
    doiToApaTitle: "Konverter DOI ke APA",
    doiToApaMetaDescription:
      "Tempel DOI (satu per baris) dan dapatkan referensi APA 7 secara instan, diambil dari metadata resmi Crossref milik penerbit. Gratis, tanpa akun.",
    doiToApaIntro:
      "DOI sudah mengarah ke metadata resmi penerbit, jadi tidak perlu lagi mengetik referensi APA secara manual. Tempel satu DOI per baris dan setiap DOI akan diubah menjadi referensi APA 7 lengkap — nama penulis dibalik, judul huruf kapital hanya di awal, nama jurnal dicetak miring, dan tautan https://doi.org/ yang diwajibkan APA.",
    doiToApaUseCase:
      "Momen yang sering terjadi: dosen meminta daftar referensi APA, dan yang Anda punya hanya tumpukan DOI yang disimpan saat membaca. Tempel semuanya, salin daftarnya.",
    doiToMlaTitle: "Konverter DOI ke MLA",
    doiToMlaMetaDescription:
      "Ubah DOI menjadi entri daftar pustaka MLA 9 secara otomatis menggunakan metadata Crossref. Tempel satu DOI per baris — gratis, tanpa perlu instalasi.",
    doiToMlaIntro:
      "MLA 9 memperlakukan artikel jurnal sebagai rangkaian 'kontainer' — judul artikel dalam tanda kutip, nama jurnal dicetak miring, volume, edisi, tahun, halaman — yang cukup merepotkan bila disusun manual. Pencarian DOI mengisi setiap bagian dari data penerbit, sehingga entri daftar pustaka langsung benar sejak awal.",
    doiToMlaUseCase:
      "Berguna saat mata kuliah humaniora mewajibkan MLA, tetapi sumber Anda berasal dari basis data ilmiah yang hanya memberi DOI.",
    doiToBibtexTitle: "Konverter DOI ke BibTeX",
    doiToBibtexMetaDescription:
      "Konversi DOI menjadi entri BibTeX untuk LaTeX dan Overleaf. Tempel satu DOI per baris, unduh file .bib siap pakai — gratis dan tanpa batas.",
    doiToBibtexIntro:
      "Setiap makalah LaTeX pada akhirnya membutuhkan file .bib. Tempel DOI satu per baris dan dapatkan entri @article yang rapi lengkap dengan kunci sitasi otomatis, siap untuk Overleaf, natbib, atau biblatex — tanpa menyalin bidang data secara manual dari halaman penerbit.",
    doiToBibtexUseCase:
      "Alur klasik: reviewer mengirimkan tiga makalah untuk disitasi, Anda punya DOI-nya, dan tenggat waktu malam ini. Tempel, unduh, langsung \\cite.",
    doiToRisTitle: "Konverter DOI ke RIS",
    doiToRisMetaDescription:
      "Ubah DOI menjadi file RIS yang bisa langsung diimpor Zotero, Mendeley, dan EndNote. Tempel DOI satu per baris — gratis, tanpa pendaftaran.",
    doiToRisIntro:
      "RIS adalah format pertukaran data yang bisa diimpor oleh semua pengelola referensi. Tempel DOI dan unduh file .ris dengan bidang TY/AU/TI/T2 langsung dari Crossref — lalu impor melalui File → Import ke Zotero, Mendeley, atau EndNote dan entrinya akan langsung terstruktur penuh.",
    doiToRisUseCase:
      "Cocok untuk memindahkan daftar DOI yang dikumpulkan manual ke pengelola referensi yang sesungguhnya, tanpa mengetik ulang satu pun nama penulis.",
    isbnToApaTitle: "Konverter ISBN ke APA",
    isbnToApaMetaDescription:
      "Ubah ISBN menjadi referensi buku APA 7 secara otomatis. Tempel satu ISBN per baris dan salin daftar yang sudah diformat — gratis, tanpa akun.",
    isbnToApaIntro:
      "ISBN di halaman hak cipta buku adalah satu-satunya yang Anda perlukan untuk referensi APA-nya. Setiap ISBN dicocokkan dengan metadata perpustakaan dan diformat mengikuti gaya APA 7 — penulis, tahun, judul dicetak miring, dan penerbit — termasuk informasi edisi jika tersedia dalam data.",
    isbnToApaUseCase:
      "Cara tercepat menyitasi tumpukan buku fisik dari perpustakaan: buka halaman hak cipta tiap buku, catat ISBN-nya, lalu tempel daftarnya di sini.",
    isbnToMlaTitle: "Konverter ISBN ke MLA",
    isbnToMlaMetaDescription:
      "Konversi ISBN menjadi entri daftar pustaka MLA 9 dalam sekali tempel. Pencarian ISBN gratis dengan hasil yang sudah diformat — tanpa perlu pendaftaran.",
    isbnToMlaIntro:
      "Entri buku dalam MLA 9 singkat — penulis, judul dicetak miring, penerbit, tahun — tetapi membalik nama penulis dan tanda baca yang tepat tetap sering membingungkan. Pencarian ISBN mengembalikan data katalog asli buku dan memformatnya sesuai templat elemen inti buku panduan MLA.",
    isbnToMlaUseCase:
      "Ideal untuk esai sastra: sitasi setiap novel dan monografi kritis di meja Anda hanya dengan mengetik nomor di sampul belakangnya.",
    isbnToBibtexTitle: "Konverter ISBN ke BibTeX",
    isbnToBibtexMetaDescription:
      "Konversi ISBN menjadi entri @book BibTeX untuk LaTeX. Tempel satu ISBN per baris, unduh file .bib — gratis dan instan.",
    isbnToBibtexIntro:
      "Buku adalah bagian yang merepotkan dalam BibTeX — tidak ada DOI untuk dicari, dan halaman penerbit jarang menawarkan ekspor .bib. Konverter ini mencocokkan setiap ISBN dengan metadata perpustakaan dan menghasilkan entri @book dengan bidang penulis, judul, penerbit, dan tahun yang sudah terisi.",
    isbnToBibtexUseCase:
      "Untuk penulis skripsi/tesis: bab metode menyitasi DOI jurnal, tetapi bab teori menyitasi dua belas buku. Ini menangani dua belas buku itu.",
    pmidToApaTitle: "Konverter PMID ke APA",
    pmidToApaMetaDescription:
      "Konversi ID PubMed menjadi referensi APA 7 secara otomatis. Tempel PMID satu per baris dan dapatkan daftar referensi yang sudah diformat — gratis.",
    pmidToApaIntro:
      "Setiap catatan PubMed memiliki PMID, dan program psikologi serta keperawatan hampir selalu mewajibkan APA. Tempel PMID satu per baris dan setiap PMID diproses melalui metadata PubMed sendiri menjadi referensi jurnal APA 7 yang lengkap, lengkap dengan tautan DOI jika tersedia dalam data.",
    pmidToApaUseCase:
      "Dibuat untuk tugas praktik berbasis bukti: strategi pencarian Anda berakhir dengan daftar PMID, dan makalah Anda membutuhkannya dalam format APA.",
    pmidToRisTitle: "Konverter PMID ke RIS",
    pmidToRisMetaDescription:
      "Ubah ID PubMed menjadi file RIS untuk Zotero, Mendeley, atau EndNote. Tempel PMID satu per baris, unduh file .ris — gratis.",
    pmidToRisIntro:
      "Alur kerja tinjauan sistematis bergantung pada file RIS. Tempel PMID dari hasil pencarian PubMed Anda dan unduh file .ris yang siap untuk alat penyaringan atau pengelola referensi Anda — setiap catatan disusun dari metadata resmi PubMed, bukan hasil scraping teks.",
    pmidToRisUseCase:
      "Berguna di tengah proses tinjauan, saat rekan kerja mengirim email 'tolong tambahkan lima studi ini juga' berupa PMID polos, sementara pustaka referensi Anda ada di EndNote.",
    arxivToBibtexTitle: "Konverter arXiv ke BibTeX",
    arxivToBibtexMetaDescription:
      "Konversi ID arXiv menjadi entri BibTeX untuk makalah LaTeX. Tempel ID seperti 2301.12345, satu per baris, dan unduh file .bib — gratis.",
    arxivToBibtexIntro:
      "Preprint terus-menerus disitasi di bidang yang berkembang cepat, dan ID arXiv (seperti 2301.12345) adalah cara preprint itu beredar. Tempel ID-nya dan dapatkan entri BibTeX lengkap dengan penulis, judul, tahun, dan tautan arXiv preprint tersebut — siap untuk file .bib makalah Anda.",
    arxivToBibtexUseCase:
      "Untuk penulis di bidang ML dan fisika yang bagian related-work-nya 80% berasal dari arXiv: kumpulkan ID selama membaca, konversi semuanya sekaligus saat menulis.",
    bibtexToApaTitle: "Konverter BibTeX ke APA",
    bibtexToApaMetaDescription:
      "Tempel atau unggah file .bib dan dapatkan daftar referensi APA 7. Mendukung file dengan banyak entri — gratis, proses berjalan di peramban Anda.",
    bibtexToApaIntro:
      "Terkadang makalah harus keluar dari LaTeX: jurnal meminta naskah dalam Word, atau panitia meminta daftar referensi berupa teks biasa. Tempel BibTeX Anda (atau unggah file .bib) dan setiap entri diproses di peramban Anda, lalu diformat sebagai daftar referensi APA 7 yang bisa langsung ditempel ke dokumen apa pun.",
    bibtexToApaUseCase:
      "Andalan untuk pengajuan hibah: daftar publikasi Anda tersimpan dalam file .bib, dan formulir pemberi dana meminta referensi berformat APA di dalam kotak teks.",
    bibtexToMlaTitle: "Konverter BibTeX ke MLA",
    bibtexToMlaMetaDescription:
      "Konversi BibTeX ke entri daftar pustaka MLA 9. Tempel atau unggah file .bib dan salin daftar yang sudah diformat — gratis, tanpa akun.",
    bibtexToMlaIntro:
      "BibTeX menyimpan bidang data mentah; MLA menentukan persis cara menyusunnya. Konverter ini memproses entri .bib Anda secara lokal dan merender setiap entri melalui templat MLA 9 — pembalikan nama penulis, judul artikel dalam tanda kutip, kontainer dicetak miring, dan tanda baca yang tepat di antara elemen.",
    bibtexToMlaUseCase:
      "Untuk peneliti lintas disiplin: referensi Anda tersimpan dalam BibTeX dari pekerjaan LaTeX sebelumnya, tetapi jurnal humaniora tujuan Anda meminta MLA.",
    bibtexToRisTitle: "Konverter BibTeX ke RIS",
    bibtexToRisMetaDescription:
      "Konversi file .bib ke RIS untuk Zotero, Mendeley, atau EndNote. Tempel atau unggah BibTeX, unduh file .ris — gratis dan offline.",
    bibtexToRisIntro:
      "Berpindah dari perangkat LaTeX ke pengelola referensi berarti menerjemahkan entri @article/@book BibTeX menjadi tag TY/AU/TI milik RIS. Konversi berjalan sepenuhnya di peramban Anda — termasuk pemetaan bidang data — dan menghasilkan file .ris yang bisa diimpor oleh pengelola referensi mana pun.",
    bibtexToRisUseCase:
      "Pemicu yang umum terjadi: rekan penulis baru menggunakan Zotero, referensi bersama Anda berupa file .bib di repositori, dan seseorang harus menjembatani keduanya.",
    bibtexToCslJsonTitle: "Konverter BibTeX ke CSL-JSON",
    bibtexToCslJsonMetaDescription:
      "Konversi BibTeX ke CSL-JSON untuk Pandoc dan Quarto. Tempel atau unggah file .bib, unduh references.json — gratis, di peramban.",
    bibtexToCslJsonIntro:
      "Pandoc dan Quarto menyitasi langsung dari CSL-JSON, dan mengonversi file .bib yang sudah ada menghilangkan satu bagian rumit dari proses build. Entri diproses di peramban Anda dan keluar sebagai array CSL-JSON yang rapi — persis bentuk yang diharapkan --bibliography=references.json.",
    bibtexToCslJsonUseCase:
      "Untuk akademisi yang berbasis Markdown dan mengonversi proyek LaTeX lama ke Quarto: bawa serta bibliografinya tanpa perlu mengedit JSON secara manual.",
    bibtexToWordTitle: "Konverter BibTeX ke Word",
    bibtexToWordMetaDescription:
      "Ubah file .bib menjadi dokumen Word dengan daftar referensi berformat APA dan indentasi menggantung. Gratis — proses berjalan di peramban Anda.",
    bibtexToWordIntro:
      "Saat file .bib perlu menjadi dokumen — bukan format data lain — konverter ini memproses BibTeX Anda secara lokal, memformat setiap entri dalam APA 7, dan mengunduh file Word dengan daftar referensi yang sudah tersusun alfabetis dan berindentasi menggantung.",
    bibtexToWordUseCase:
      "Langkah terakhir dalam alur kerja: jurnal menerima makalah Anda tetapi meminta daftar referensi akhir sebagai file Word yang bisa disunting, sementara sumber data utama Anda adalah BibTeX.",
    risToApaTitle: "Konverter RIS ke APA",
    risToApaMetaDescription:
      "Tempel atau unggah hasil ekspor RIS dan dapatkan daftar referensi APA 7. Berfungsi dengan ekspor dari Zotero, Mendeley, EndNote, dan basis data — gratis.",
    risToApaIntro:
      "Tombol Export di setiap basis data menghasilkan RIS; tugas Anda membutuhkan APA. Tempel hasil ekspornya (atau unggah file .ris) dan setiap catatan TY/AU/TI diproses di peramban Anda dan dirender sebagai referensi APA 7 — tanpa perlu memasang pengelola referensi apa pun.",
    risToApaUseCase:
      "Jalan pintas dari basis data perpustakaan: ekspor hasil pencarian Anda sebagai RIS, konversi di sini, dan lewati proses menyiapkan Zotero hanya untuk satu makalah.",
    risToMlaTitle: "Konverter RIS ke MLA",
    risToMlaMetaDescription:
      "Konversi ekspor RIS dari basis data atau pengelola referensi menjadi entri daftar pustaka MLA 9. Tempel atau unggah — gratis, tanpa pendaftaran.",
    risToMlaIntro:
      "JSTOR, ProQuest, dan EBSCO semuanya mengekspor RIS, dan jurusan bahasa Inggris semuanya menginginkan MLA. Halaman ini menjembatani keduanya: catatan diproses secara lokal dan dirender melalui templat elemen inti MLA 9, siap ditempel ke halaman daftar pustaka Anda.",
    risToMlaUseCase:
      "Dibuat untuk malam sebelum esai dikumpulkan: sepuluh sumber diekspor dari JSTOR sebagai citations.ris, dan tidak ada niat sedikit pun untuk memformatnya secara manual.",
    risToBibtexTitle: "Konverter RIS ke BibTeX",
    risToBibtexMetaDescription:
      "Konversi RIS ke BibTeX untuk LaTeX dan Overleaf. Tempel atau unggah hasil ekspor .ris, unduh file .bib yang bersih — gratis, di peramban.",
    risToBibtexIntro:
      "Menuju arah LaTeX: pengelola referensi dan basis data 'berbicara' RIS, sementara build makalah Anda membutuhkan .bib. Catatan dikonversi sepenuhnya di peramban Anda — tipe dipetakan dari tag TY, kunci sitasi dibuat otomatis — menjadi file yang langsung diterima Overleaf.",
    risToBibtexUseCase:
      "Umum terjadi dalam kolaborasi: pengguna Zotero mengekspor RIS, pengguna LaTeX memprosesnya lewat halaman ini, dan keduanya tetap memakai alat masing-masing.",
    risToCslJsonTitle: "Konverter RIS ke CSL-JSON",
    risToCslJsonMetaDescription:
      "Konversi ekspor RIS ke CSL-JSON untuk alur kerja Pandoc dan Quarto. Tempel atau unggah file .ris, unduh references.json — gratis.",
    risToCslJsonIntro:
      "Bagi pengguna Pandoc dan Quarto, CSL-JSON adalah format bibliografi asli. Berikan halaman ini RIS hasil ekspor basis data atau pengelola referensi Anda, dan dapatkan kembali array JSON terstruktur — setiap catatan diproses secara lokal, tidak ada yang diunggah ke mana pun.",
    risToCslJsonUseCase:
      "Cocok untuk alur kerja docs-as-code: reviewer mengirim lampiran RIS, file sitasi di repositori Anda adalah references.json, dan halaman ini menjadi penghubungnya.",
    cslJsonToBibtexTitle: "Konverter CSL-JSON ke BibTeX",
    cslJsonToBibtexMetaDescription:
      "Konversi CSL-JSON (hasil ekspor Pandoc/Quarto/Zotero) ke BibTeX. Tempel atau unggah file .json, unduh file .bib — gratis, di peramban.",
    cslJsonToBibtexIntro:
      "Kadang alurnya terbalik: bibliografi yang lahir dari pipeline Pandoc atau Zotero perlu memasok build LaTeX. Konverter ini membaca array CSL-JSON di peramban Anda dan menghasilkan entri BibTeX dengan tipe dan bidang data yang dipetakan kembali dari model CSL.",
    cslJsonToBibtexUseCase:
      "Untuk penulis Quarto yang rekan penulisnya bersikeras memakai Overleaf: jadikan references.json sebagai acuan utama dan hasilkan file .bib sesuai kebutuhan.",
    cslJsonToRisTitle: "Konverter CSL-JSON ke RIS",
    cslJsonToRisMetaDescription:
      "Konversi CSL-JSON ke RIS agar Zotero, Mendeley, atau EndNote bisa mengimpornya. Tempel atau unggah file .json, unduh file .ris — gratis.",
    cslJsonToRisIntro:
      "CSL-JSON sangat cocok di dalam pipeline Pandoc, tetapi sulit dibaca oleh sebagian besar dialog impor pengelola referensi. Mengonversinya ke RIS membuat catatan yang sama bisa diimpor secara universal — setiap entri dipetakan ke tag TY/AU/TI di peramban Anda, tidak ada yang dikirim ke server mana pun.",
    cslJsonToRisUseCase:
      "Masalah serah terima: bibliografi Anda berupa references.json dalam repositori git, dan pembimbing Anda meminta versi 'di EndNote' pada hari Jumat.",
  },

  // The infinite-scroll style list shared by the country and subject pages and by the
  // /citation-styles hub. It is a client component, so these arrive as a prop rather
  // than through `getDictionary` — pulling all 17 dictionaries into the browser bundle
  // to label a search box is the thing `link-path.ts` exists to avoid.
  stylesBrowser: {
    defaultTitle: "Semua Gaya Sitasi",
    styleSingular: "gaya",
    stylePlural: "gaya",
    found: "ditemukan",
    filterPlaceholder: "Saring gaya...",
    noMatches: "Tidak ada gaya yang cocok dengan pencarian Anda.",
    loadingMore: "Memuat lebih banyak gaya...",
    loadMore: "Muat lebih banyak ({count} tersisa)",
    showingAll: "Menampilkan semua {count} gaya",
    internationalLabel: "Internasional",
  },

  footer: {
    tagline:
      "Pembuat sitasi gratis dengan {count} gaya. Tanpa akun, tanpa langganan berbayar, tanpa batas.",
    freeTools: "Alat gratis",
    resources: "Sumber daya",
    legal: "Hukum",
    language: "Bahasa",
    languageLabel: "Pilih bahasa Anda",
    rights:
      "Sitasi diformat menggunakan definisi resmi Citation Style Language.",
    popularStyles: "Gaya populer",
    about: "Tentang",
    privacy: "Privasi",
    terms: "Ketentuan",
    contact: "Kontak",
    copyright: "© {year} CitationEasy. Gratis digunakan.",
    poweredBy: "Ditenagai oleh",
    allTools: "Semua alat menulis",
    citationGuides: "Panduan sitasi",
    allStyles: "Semua gaya sitasi",
    citationGlossary: "Glosarium sitasi",
    howToCiteAny: "Cara menyitasi sumber apa pun",
  },

  faq: {
    heading: "Pertanyaan yang sering diajukan",
    homeQ1: "Apakah CitationEasy benar-benar gratis?",
    homeA1:
      "Ya. CitationEasy sepenuhnya gratis: tanpa pendaftaran, tanpa batas, dan tanpa versi berbayar. Seluruh {count} gaya sitasi tersedia untuk semua orang.",
    homeQ2: "Gaya sitasi apa saja yang didukung?",
    homeA2:
      "Seluruh {count} gaya dari proyek Citation Style Language, termasuk APA edisi ke-7, MLA edisi ke-9, Chicago, Harvard, Vancouver, IEEE, AMA, dan Turabian.",
    homeQ3: "Apakah saya perlu akun?",
    homeA3:
      "Tidak. CitationEasy berjalan sepenuhnya di peramban Anda dan daftar pustaka disimpan di perangkat Anda sendiri. Tidak ada yang diunggah dan tidak ada yang perlu didaftarkan.",
    homeQ4: "Bisakah saya membuat sitasi dalam bahasa saya?",
    homeA4:
      "Bisa. Bahasa sitasi adalah pengaturan terpisah dari bahasa situs, jadi Anda dapat bekerja dalam bahasa Indonesia sambil menghasilkan rujukan dalam bahasa tulisan Anda.",
    styleQ1: "Apakah pembuat sitasi {style} gratis?",
    styleA1:
      "Ya. Membuat sitasi {style} gratis dan tanpa batas, tanpa perlu akun. Tempelkan DOI, URL, ISBN, atau entri BibTeX lalu salin rujukan yang sudah jadi.",
    styleQ2: "Bagaimana cara menyitasi sumber dengan gaya {style}?",
    styleA2:
      "Tempelkan DOI, URL, ISBN, atau entri BibTeX sumber ke pembuat sitasi di halaman ini. Gaya {style} sudah terpilih, sehingga rujukan dan sitasi dalam teks langsung muncul.",
    styleQ3: "Seberapa akurat pemformatan {style}?",
    styleA3:
      "Setiap rujukan dibangun dari definisi {style} resmi yang diterbitkan proyek Citation Style Language — berkas yang sama dengan yang dipakai Zotero dan Mendeley — bukan dari perkiraan aturannya.",
  },

  tool: {
    modeLabel: "Mode masukan sitasi",
    modeAuto: "URL / DOI / ISBN",
    modeBook: "Cari buku",
    modeArticles: "Cari artikel",
    modeManual: "Isi manual",
    errorEnterManually: "Isi detailnya secara manual",
    autoLabel: "Tempel URL, DOI, PMID, ID arXiv, ISBN, atau BibTeX",
    autoHint:
      "Kami mendeteksi jenisnya secara otomatis dan mengambil metadatanya. Tempel satu pengenal per baris untuk menyitasi seluruh daftar sekaligus.",
    generate: "Buat sitasi",
    generating: "Membuat…",
    bookSearchLabel: "Cari berdasarkan judul, penulis, atau ISBN",
    bookSearchEmpty: "Belum ada hasil. Klik Cari untuk menemukan buku.",
    bookSearchSource: "Mencari di katalog Open Library dengan jutaan buku",
    worksSearchLabel: "Cari berdasarkan judul artikel atau penulis",
    worksSearchEmpty: "Belum ada hasil. Klik Cari untuk menemukan artikel.",
    worksSearchSource:
      "Mencari di katalog Crossref: artikel jurnal, makalah konferensi, dan bab buku",
    showingResults: "Menampilkan {shown} dari {total} hasil",
    search: "Cari",
    searching: "Mencari…",
    bulkResults: "Hasil sitasi massal",
    copy: "Salin",
    copied: "Tersalin!",
    copyHint: "Salin dan tempel ke tulisan Anda",
    resultTitle: "Sitasi terformat",
    edit: "Edit",
    completeFields: "Lengkapi",
    fieldsIncomplete: "other:{count} kolom belum lengkap",
    outputLanguage: "Bahasa",
    sourceType: "Jenis sumber",
    fieldAuthors: "Penulis",
    fieldAuthorsHint: "Santoso, Budi atau Budi Santoso",
    fieldTitle: "Judul artikel atau buku",
    fieldBookTitle: "Judul buku",
    fieldBookTitleHint: "Judul buku atau bunga rampai",
    fieldEditors: "Editor",
    fieldJournal: "Jurnal / publikasi",
    fieldJournalHint: "Nama jurnal atau publikasi",
    fieldPublisher: "Penerbit / situs",
    fieldPublisherHint: "Nama penerbit atau situs web",
    fieldDate: "Tanggal / tahun",
    fieldVolume: "Volume",
    fieldIssue: "Nomor",
    fieldPages: "Halaman",
    fieldFormat: "Format / media",
    fieldAuthorsGroup: "Penulis kelompok atau organisasi",
    fieldAuthorsGroupHint:
      "Untuk mencantumkan kelompok bersama orang, apit dengan kurung kurawal: {R Core Team}, Budi Santoso",
    fieldTranslators: "Penerjemah",
    fieldInterviewers: "Pewawancara",
    fieldVersion: "Versi",
    fieldCourt: "Pengadilan",
    fieldIssuingAuthority: "Otoritas penerbit",
    fieldPatentNumber: "Nomor paten",
    fieldEpisodeNumber: "Nomor episode",
    fieldLawNumber: "Nomor undang-undang atau RUU",
    fieldReportNumber: "Nomor laporan",
    fieldReviewedTitle: "Judul karya yang diulas",
    fieldReviewedAuthors: "Penulis karya yang diulas",
    inTextCitation: "Sitasi dalam teks",
    quickEdit: "Edit cepat",
    quickEditHint: "Perbarui metadata lalu buat ulang sitasinya.",
    update: "Perbarui",
    saving: "Menyimpan…",
    fieldAuthor: "Penulis",
    fieldDateShort: "Tanggal",
    fieldTitleShort: "Judul",
  },

  toolCollections: {
    "citation-generators": "Generator sitasi",
    "citation-tools": "Alat sitasi dan referensi",
    "paper-formatting": "Format makalah",
    "essay-writing": "Menulis esai dan makalah",
    "writing-analysis": "Analisis dan penyuntingan tulisan",
    "word-counters": "Penghitung dan keterbacaan",
    vocabulary: "Kosakata dan pencari kata",
    "research-tools": "Riset dan publikasi",
    statistics: "Kalkulator statistik",
    math: "Kalkulator matematika",
    science: "Kalkulator sains dan laboratorium",
    charts: "Grafik dan diagram",
    economics: "Ekonomi, bisnis, dan keuangan",
    grades: "Kalkulator IPK dan nilai",
    study: "Belajar dan produktivitas",
    classroom: "Kelas dan bahan cetak",
    random: "Generator dan pengundi acak",
    "text-tools": "Pembersihan dan format teks",
    "fancy-text": "Teks hias dan simbol",
    language: "Bahasa dan transliterasi",
    ciphers: "Kode dan sandi",
    converters: "Konverter satuan, tanggal, dan angka",
    developer: "Data, markup, dan kode",
  },
  bib: {
    title: "Daftar pustaka saya",
    studioTitle: "Studio daftar pustaka",
    studioProjects: "Proyek",
    studioExplore: "Jelajahi",
    studioExploreIntro:
      "Panduan, alat, dan semua gaya sitasi hanya sejauh satu klik.",
    studioStyleGuide: "Panduan gaya {style}",
    studioStyleGuideHint: "Aturan, contoh, dan format sitasi dalam teks",
    studioGenerator: "Generator sitasi",
    studioNewProject: "Proyek baru",
    studioSwitchProject: "Ganti proyek",
    studioAddSource: "Tambah sumber",
    studioAddSourceHint:
      "Tempel DOI, URL, atau ISBN, cari buku dan artikel, atau masukkan detail secara manual. Semua yang Anda simpan masuk ke proyek ini.",
    studioDoneAdding: "Selesai",
    studioReferences: "Referensi",
    studioReferenceCount: "{count} referensi",
    studioInspectorTitle: "Detail referensi",
    studioInspectorEmpty:
      "Pilih referensi untuk melihat sitasi dalam teks, catatan, dan detail sumbernya.",
    studioSavedLocally: "Tersimpan di browser ini",
    studioOpen: "Buka Studio Bibliografi",
    studioViewInStudio: "Lihat di Studio",
    studioFooterSaved: "{count} tersimpan di Studio Bibliografi Anda",
    studioFooterEmpty:
      "Sitasi yang tersimpan membentuk bibliografi lengkap di Studio",
    studioClearSelection: "Batalkan pilihan",
    studioDeleteSelected: "Hapus yang dipilih",
    studioDeleteSelectedBody:
      "Hapus {count} sitasi dari “{name}”? Tindakan ini tidak dapat dibatalkan.",
    studioDeletedMany: "{count} sitasi dihapus",
    studioMoveTo: "Pindahkan ke",
    studioCopyTo: "Salin ke",
    studioSearchShortcut: "Tekan / untuk mencari",
    studioStyle: "Gaya",
    studioCopyEntry: "Salin entri",
    studioEntryCopied: "Entri disalin",
    studioSourceDetails: "Detail sumber",
    studioEmptyTitle: "Proyek ini kosong",
    studioEmptyBody:
      "Tambahkan sumber pertama Anda di atas, atau impor pustaka BibTeX, RIS, atau CSL-JSON yang sudah ada.",
    studioBackup: "Cadangan",
    sharedTitle: "Daftar pustaka yang dibagikan",
    save: "Simpan",
    saving: "Menyimpan…",
    saved: "Tersimpan",
    searchPlaceholder: "Cari sitasi…",
    empty: "Belum ada sitasi tersimpan",
    emptySearch: "Tidak ada sitasi yang cocok dengan pencarian Anda.",
    countIn: "Sitasi di {name}: {count}",
    savedOn: "Disimpan {date}",
    emptyInBib:
      "Belum ada sitasi di daftar pustaka ini. Buat dan simpan sitasi, atau impor pustaka BibTeX, RIS, atau CSL-JSON.",
    savedToast: "Sitasi disimpan ke daftar pustaka",
    copyAll: "Salin semua",
    copyAllTitle: "Salin semua sitasi",
    export: "Ekspor",
    exportTitle: "Ekspor daftar pustaka",
    import: "Impor",
    importTitle: "Impor referensi",
    importLabel: "Impor referensi (BibTeX, RIS, atau CSL-JSON)",
    importing: "Mengimpor…",
    importFailed: "Impor gagal. Silakan coba lagi.",
    importSummary:
      "Diimpor: {added} · Duplikat dilewati: {duplicates} · Melebihi batas: {overLimit} · Gagal: {failed}",
    importUnreadable: "Tidak dapat membaca berkas.",
    importUnparseable: "Tidak dapat mengimpor referensi.",
    importReviewTitle: "Tinjau impor",
    importReviewIntro:
      "Tinjau {total} referensi {format} sebelum memformat dan menyimpannya.",
    importReviewCount: "{included} dari {total} disertakan",
    importSelectAll: "Sertakan semua",
    importExcludeAll: "Kecualikan semua",
    importLimitNotice:
      "{count} referensi yang melebihi batas 200 entri tidak akan diimpor.",
    importDuplicateExisting:
      "Kemungkinan duplikat “{title}” yang sudah disimpan",
    importDuplicateBatch: "Kemungkinan duplikat “{title}” dalam impor ini",
    importMissingField: "{field} tidak ada",
    importUntitled: "Referensi tanpa judul",
    importReview: "Tinjau referensi",
    importCommit: "Format dan impor",
    importBack: "Kembali",
    importOutcomeTitle: "Impor selesai",
    importOutcomeSummary:
      "Ditambahkan: {added} · Duplikat dilewati: {duplicates} · Dikecualikan: {excluded} · Melebihi batas: {overLimit} · Gagal: {failed}",
    sortBy: "Urutkan menurut",
    sortTitle: "Urutkan daftar pustaka",
    sortAuthor: "Penulis (A–Z)",
    sortNewest: "Tanggal ditambahkan (terbaru)",
    sortOldest: "Tahun (terlama dulu)",
    sortManual: "Urutan manual",
    backupAll: "Cadangan proyek lengkap (.json)",
    backupDownloaded: "Cadangan proyek lengkap diunduh",
    backupUnreadable: "File cadangan tidak dapat dibaca.",
    restore: "Pulihkan",
    restoreTitle: "Pulihkan semua proyek bibliografi",
    restoreWarning:
      "Cadangan akan divalidasi terlebih dahulu, lalu mengganti semua bibliografi yang tersimpan di browser ini. Tindakan ini tidak dapat dibatalkan.",
    restoreChoose: "Pilih cadangan CitationEasy (.json)",
    replaceAndRestore: "Ganti dan pulihkan",
    restoreComplete: "Semua proyek bibliografi dipulihkan",
    restoreInvalid: "Ini bukan cadangan proyek CitationEasy yang valid.",
    selectAllVisible: "Pilih semua yang ditampilkan",
    selectedCount: "{count} dipilih",
    clusterOpen: "Kutip bersama",
    clusterTitle: "Kutipan dalam teks gabungan",
    clusterDescription:
      "Buat satu klaster kutipan dari referensi yang dipilih. Gaya yang dipilih mengatur urutan, tanda baca, dan penomoran.",
    clusterTarget: "Keluaran",
    clusterLocatorOptional: "Lokator opsional",
    clusterBuildCopy: "Buat dan salin kutipan",
    clusterBuilding: "Membuat kutipan…",
    clusterCopied: "Kutipan gabungan disalin",
    clusterFailed: "Kutipan gabungan tidak dapat dibuat. Silakan coba lagi.",
    destination: "Bibliografi tujuan",
    chooseDestination: "Pilih bibliografi…",
    copySelected: "Salin",
    moveSelected: "Pindahkan",
    copyComplete: "{count} sitasi disalin. {skipped} duplikat dilewati.",
    moveComplete:
      "{count} sitasi dipindahkan. {skipped} duplikat tetap di sumber.",
    selectCitation: "Pilih {title}",
    moveUp: "Pindahkan ke atas",
    moveDown: "Pindahkan ke bawah",
    deleteTitle: "Hapus sitasi",
    deleteConfirm: "Hapus sitasi?",
    deleted: "Sitasi dihapus",
    editTitle: "Edit sitasi",
    close: "Tutup",
    copiedAll: "Semua sitasi tersalin!",
    copiedAnnotated: "Daftar pustaka beranotasi tersalin!",
    copiedBibtex: "BibTeX tersalin!",
    copiedBulleted: "Daftar berpoin tersalin!",
    copiedNumbered: "Daftar bernomor tersalin!",
    copiedHtml: "Cuplikan HTML tersalin!",
    downloadedWord: "Dokumen Word diunduh",
    downloadedRtf: "Berkas RTF diunduh",
    downloadedRis: "Berkas RIS diunduh",
    downloadedCsl: "Berkas CSL-JSON diunduh",
    downloadedAnnotated: "Daftar pustaka beranotasi diunduh",
    copyFailed: "Gagal menyalin ke papan klip",
    shareCopied:
      "Tautan tersalin! Siapa pun yang memilikinya dapat melihat dan mengimpor daftar ini.",
    shareFailed: "Tidak dapat membuat tautan berbagi",
    regenerateFailed: "Gagal membuat ulang sitasi",
    updateFailed: "Gagal memperbarui sitasi",
    fieldAuthor: "Penulis",
    fieldTitle: "Judul",
    fieldDate: "Tanggal",
    fieldPublisher: "Penerbit",
    fieldVolume: "Volume",
    fieldIssue: "Nomor",
    fieldPages: "Halaman",
    fieldUrl: "URL",
    fieldAccessed: "Tanggal akses",
    fieldEditor: "Editor",
    fieldEvent: "Lokasi acara",
    noteLabel: "Anotasi untuk sumber ini",
    noteEdit: "Edit catatan ini",
    notePlaceholder:
      "Ringkas sumbernya, nilai, dan jelaskan kaitannya dengan tulisan Anda…",
    noteRemoved: "Catatan dihapus",
    noteSave: "Simpan catatan",
    noteCancel: "Batal",
    noteAdd: "Tambah catatan",
    noteWords: "{count} kata",
    noteSaved: "Catatan tersimpan ({count} kata)",
    noteClickToEdit: "klik untuk mengedit",
    inTextCopy: "Salin sitasi dalam teks untuk sumber ini",
    inTextSelect: "Pilih sitasi di bawah untuk menyalinnya.",
    inTextFailed: "Tidak dapat menyusun sitasi dalam teks. Silakan coba lagi.",
    locator: "Penunjuk",
    locatorType: "Jenis penunjuk",
    locatorPage: "Halaman",
    locatorChapter: "Bab",
    locatorSection: "Bagian",
    locatorParagraph: "Paragraf",
    locatorLine: "Baris",
    locatorVerse: "Ayat",
    reformat: "Format ulang",
    reformatTitle: "Format ulang semua sitasi dalam gaya lain",
    reformatHeading: "Format ulang semuanya dalam satu gaya",
    reformatChoose: "Pilih gaya…",
    reformatFailed: "Format ulang gagal. Daftar pustaka Anda tidak berubah.",
    sortOrder: "Kriteria urutan",
    copyToClipboard: "Salin ke papan klip",
    numberedList: "Daftar bernomor",
    bulletedList: "Daftar berpoin",
    htmlSnippet: "Cuplikan HTML",
    copyWithAnnotations: "Salin beserta anotasi",
    wordAnnotated: "Dokumen Word beranotasi (.doc)",
    downloadFile: "Unduh berkas",
    wordDocument: "Dokumen Word (.doc)",
    copyShareLink: "Salin tautan berbagi",
    print: "Cetak…",
    printFailed: "Pop-up diblokir — izinkan pop-up untuk mencetak",
    font: "Font",
    sitePublication: "Situs / nama publikasi",
    importIntro:
      "Tempel atau unggah berkas BibTeX (.bib), RIS (.ris), atau CSL-JSON (.json)",
    importUpload: "Unggah berkas .bib, .ris, atau .json",
    importPaste: "Atau tempel BibTeX, RIS, atau CSL-JSON",
    cancel: "Batal",
    done: "Selesai",
    delete: "Hapus",
    deleteBody: "Sitasi ini akan dihapus permanen dari daftar pustaka Anda.",
    editBody: "Perbarui metadata lalu simpan untuk membuat ulang sitasinya.",
    reformatExplain:
      "Menyusun ulang seluruh {count} entri dari data sumber yang tersimpan — tidak ada yang diunduh ulang dan tidak ada sumber yang hilang.",
    inTextHeading: "Sitasi dalam teks",
    inTextLocatorHint:
      "Tambahkan halaman atau penunjuk lain untuk mengaitkan sitasi ke bagian tertentu sumbernya — sebagian besar gaya mensyaratkannya untuk kutipan langsung. Kosongkan untuk bentuk sederhana.",
    inTextCopyButton: "Salin sitasi dalam teks",
    mixedStyles: "Daftar pustaka ini mencampur {count} gaya sitasi ({styles}).",
    mixedStylesAction:
      "Gunakan {action} untuk menyeragamkannya dalam satu gaya sebelum dikumpulkan.",
    selectBibliography: "Pilih daftar pustaka",
    newBibliography: "Daftar pustaka baru",
    moreOptions: "Opsi lainnya",
    rename: "Ganti nama",
    removeDuplicates: "Hapus duplikat",
    cannotDeleteOnly: "Daftar pustaka satu-satunya tidak dapat dihapus",
    newBibliographyBody: "Buat daftar pustaka untuk makalah atau proyek lain.",
    bibliographyName: "Nama daftar pustaka",
    create: "Buat",
    renameBibliography: "Ganti nama daftar pustaka",
    renameBibliographyBody: "Masukkan nama baru untuk “{name}”.",
    newName: "Nama baru",
    duplicateRemovedOne: "{count} duplikat dihapus",
    duplicateRemovedMany: "{count} duplikat dihapus",
    noDuplicates: "Tidak ditemukan referensi duplikat",
    removeDuplicatesConfirm: "Hapus referensi duplikat?",
    removeDuplicatesBody:
      "Tindakan ini memindai “{name}” untuk sumber yang sama (berdasarkan DOI, ISBN, atau judul, tahun, dan penulis) lalu menyimpan satu salinan. Referensi yang tidak dapat dicocokkan tidak diubah.",
    deleteBibliographyConfirm: "Hapus daftar pustaka?",
    deleteBibliographyBody:
      "Tindakan ini akan menghapus “{name}” dan semua {count} sitasinya secara permanen.",
  },

  bibliographyPage: {
    metaTitle: "Studio daftar pustaka - atur, anotasi, dan ekspor sitasi",
    metaDescription:
      "Buat dan kelola proyek daftar pustaka pribadi di browser. Cari, urutkan, anotasi, edit, format ulang, impor, ekspor, dan bagikan tanpa akun.",
    keyword1: "pembuat daftar pustaka",
    keyword2: "pengelola sitasi",
    keyword3: "alat daftar pustaka beranotasi",
    ogTitle: "Studio daftar pustaka",
    ogDescription:
      "Ruang kerja pribadi satu halaman untuk mengatur, memformat, menganotasi, mengimpor, dan mengekspor sitasi.",
    ogImageTitle: "Studio daftar pustaka",
    ogImageSubtitle:
      "Atur, anotasi, format ulang, ekspor, dan bagikan referensi Anda.",
    ogKind: "Ruang kerja sitasi",
    breadcrumb: "Studio daftar pustaka",
    eyebrow: "Ruang kerja pribadi di browser",
    lead: "Kelola semua referensi makalah di satu tempat. Proyek tetap berada di browser ini kecuali Anda sengaja mengekspor atau membagikannya.",
    privacyTitle: "Pribadi secara default",
    privacyBody:
      "Proyek dan anotasi memakai penyimpanan lokal browser. Tautan berbagi memuat sitasi tetapi sengaja tidak menyertakan catatan pribadi.",
    workflowTitle: "Dari daftar sumber hingga makalah akhir",
    workflowBody:
      "Beralih proyek, cari dan urutkan referensi, tambah anotasi atau penunjuk lokasi, perbaiki metadata, dan format ulang seluruh daftar dalam satu gaya.",
    formatsTitle: "Impor referensi dan bawa ke mana saja",
    formatsBody:
      "Impor BibTeX, RIS, atau CSL-JSON. Salin daftar terformat atau ekspor Word, RTF, RIS, CSL-JSON, HTML, BibTeX, dan versi beranotasi.",
  },

  // The 95-term glossary: /glossary and /glossary/[slug].
  //
  // The chrome only. Each term's own prose — `short`, the `body` paragraphs, the
  // example — is ~10,600 words that cannot live in a flat string map and must not be
  // copied verbatim into sixteen files; it lives in `src/content/glossary/<locale>.json`
  // and is read through `lib/localized-content.ts`.
  glossaryPage: {
    metaTitle: "{term} - definisi dan contoh",
    notFoundTitle: "Istilah tidak ditemukan",
    keywordDefinition: "definisi {term}",
    keywordWhatIs: "apa itu {term}",
    ogTitle: "{term} - glosarium CitationEasy",
    ogKind: "Glosarium sitasi",
    breadcrumb: "Glosarium",
    alsoCalled: "Juga disebut: {aliases}",
    doItHeading: "Lakukan di CitationEasy",
    seeAlsoHeading: "Lihat juga",
    moreInHeading: "Lainnya di {category}",
    navLabel: "Navigasi glosarium",
    allTermsLink: "Semua {count} istilah glosarium",
    generatorLink: "Pembuat sitasi gratis",
    termSetName: "Glosarium sitasi CitationEasy",
    hubMetaTitle: "Glosarium sitasi - {count} istilah dijelaskan",
    hubMetaDescription:
      "Definisi sederhana dari {count} istilah sitasi dan penulisan akademik: et al., ibid., DOI, indentasi gantung, patchwriting, version of record, dan lainnya — masing-masing dengan contoh.",
    hubKeyword1: "glosarium sitasi",
    hubKeyword2: "istilah sitasi",
    hubKeyword3: "glosarium penulisan akademik",
    hubKeyword4: "apa arti et al",
    hubKeyword5: "apa itu DOI",
    hubKeyword6: "terminologi rujukan",
    hubOgTitle: "Glosarium sitasi",
    hubOgDescription:
      "Definisi {count} istilah sitasi dan penulisan akademik, dengan contoh.",
    hubOgImageTitle: "Glosarium Sitasi",
    hubOgImageSubtitle:
      "{count} istilah sitasi dan penulisan akademik, dijelaskan dengan bahasa sederhana beserta contoh.",
    hubOgKind: "Referensi",
    hubTermSetDescription:
      "Definisi {count} istilah sitasi, rujukan, dan penulisan akademik.",
    hubCollectionName: "Glosarium sitasi",
    hubCollectionDescription:
      "Definisi sederhana dari {count} istilah sitasi dan penulisan akademik.",
    hubHeading: "Glosarium sitasi",
    hubIntro:
      "{count} istilah dari sitasi dan penulisan akademik, dijelaskan dengan bahasa sederhana beserta contoh — singkatan yang muncul dalam panduan gaya, bagian-bagian penyusun sebuah referensi, pengenal yang memastikan identitas sumber, dan kosakata penerbitan ilmiah.",
    hubJumpLabel: "Lompat ke huruf",
    hubBrowseHeading: "Jelajahi menurut topik",
    hubAllHeading: "Semua istilah A–Z",
    hubWorkHeading: "Terapkan istilahnya",
    hubWorkGenerator: "Pembuat sitasi gratis",
    hubWorkStyles: "Panduan gaya sitasi",
    hubWorkHowTo: "Cara menyitasi sumber apa pun",
    hubWorkCompare: "Bandingkan gaya sitasi",
    hubWorkTools: "Alat menulis dan sitasi",
    hubWorkFaq: "Tanya jawab sitasi",
  },

  // /faq — the 17-question hub. The questions and answers themselves are in
  // `src/data/faq.ts` (the one source the API, the MCP tool and /md also read); this is
  // the page around them.
  faqPage: {
    metaTitle:
      "Tanya Jawab Sitasi - Jawaban Cepat untuk Pertanyaan Sitasi Umum",
    metaDescription:
      "Jawaban cepat dan akurat untuk pertanyaan sitasi yang sering ditanyakan mahasiswa: DOI, sumber tanpa penulis, et al., indentasi gantung, menyitasi AI, aturan plagiarisme, APA vs MLA, dan lainnya — lengkap dengan tautan ke panduan lengkap.",
    ogTitle: "Tanya Jawab Sitasi",
    ogDescription:
      "Jawaban cepat untuk pertanyaan sitasi paling umum, dari DOI dan et al. hingga menyitasi ChatGPT.",
    ogImageTitle: "Pertanyaan dan Jawaban Sitasi",
    ogImageSubtitle:
      "Jawaban singkat dan akurat untuk pertanyaan yang sering ditanyakan mahasiswa tentang sitasi.",
    ogKind: "FAQ",
    breadcrumbLabel: "Remah navigasi",
    breadcrumbHome: "Beranda",
    breadcrumbCurrent: "Tanya Jawab Sitasi",
    heading: "Tanya Jawab Sitasi",
    intro:
      "Jawaban cepat dan akurat untuk pertanyaan sitasi yang sering ditanyakan mahasiswa — lengkap dengan tautan ke panduan atau alat lengkap saat Anda butuh penjelasan lebih dalam.",
    contentsLabel: "Daftar isi Tanya Jawab",
    stillStuckHeading: "Masih bingung?",
    stillStuckBody:
      "Jelajahi [pustaka panduan lengkap](/guides), lihat [lembar contekan gaya](/cheat-sheets), cari istilahnya di [glosarium sitasi](/glossary), [cari di seluruh situs](/search), atau langsung [buat sitasinya](/) dan biarkan pembuat sitasi menerapkan aturannya untuk Anda.",
  },

  // /cheat-sheets and its three style sheets. The citation FORMATS in them
  // ("Author, A. A. (Year)…") are the styles' own templates and stay as they are in
  // every language, exactly as the per-style examples do; the labels around them do not.
  cheatSheets: {
    hubMetaTitle: "Lembar Contekan Gaya Sitasi - Panduan Referensi Cepat",
    hubMetaDescription:
      "Lembar contekan referensi cepat untuk gaya sitasi APA, MLA, dan Chicago. Panduan ramah cetak dengan contoh jenis sumber umum.",
    hubBreadcrumbHome: "Beranda",
    hubBreadcrumbCurrent: "Lembar Contekan Gaya Sitasi",
    hubBackLink: "← Kembali ke Pembuat Sitasi",
    hubHeading: "Lembar Contekan Gaya Sitasi",
    hubIntro:
      "Panduan referensi cepat untuk gaya sitasi paling populer. Ramah cetak dan selalu diperbarui.",
    hubApaTitle: "Lembar Contekan APA Edisi ke-7",
    hubApaDesc: "Psikologi, ilmu sosial, pendidikan, keperawatan",
    hubMlaTitle: "Lembar Contekan MLA Edisi ke-9",
    hubMlaDesc: "Sastra, bahasa, humaniora, kajian budaya",
    hubChicagoTitle: "Lembar Contekan Gaya Chicago",
    hubChicagoDesc: "Sejarah, sejarah seni, filsafat, agama",
    backToSheets: "← Kembali ke Lembar Contekan",
    generalRules: "Aturan Umum",
    inTextCitations: "Sitasi Dalam Teks",
    colSituation: "Situasi",
    colFormat: "Format",
    colExample: "Contoh",
    book: "Buku",
    journalArticle: "Artikel Jurnal",
    website: "Situs Web",
    apaMetaTitle: "Lembar Contekan APA Edisi ke-7 - Panduan Referensi Cepat",
    apaMetaDescription:
      "Lembar contekan sitasi APA edisi ke-7 dengan contoh untuk buku, jurnal, situs web, dan lainnya. Referensi cepat yang ramah cetak.",
    apaHeading: "Lembar Contekan APA Edisi ke-7",
    apaLead: "Referensi cepat untuk format sitasi APA yang paling umum.",
    apaRule1:
      'Gunakan **indentasi gantung** (baris pertama rata kiri, baris berikutnya diberi indentasi 0,5" (1,27 cm))',
    apaRule2: "Gunakan spasi ganda untuk semua entri",
    apaRule3: "Urutkan menurut abjad nama belakang penulis",
    apaRule4: "Cetak miring judul buku, jurnal, dan volume",
    apaRule5: "Gunakan DOI jika tersedia",
    apaRow1Situation: "1 penulis",
    apaRow1Format: "(Author, Year)",
    apaRow1Example: "(Smith, 2024)",
    apaRow2Situation: "2 penulis",
    apaRow2Format: "(Author & Author, Year)",
    apaRow2Example: "(Smith & Jones, 2024)",
    apaRow3Situation: "3+ penulis",
    apaRow3Format: "(First Author et al., Year)",
    apaRow3Example: "(Smith et al., 2024)",
    apaRow4Situation: "Kutipan langsung",
    apaRow4Format: "(Author, Year, p. #)",
    apaRow4Example: "(Smith, 2024, p. 45)",
    apaRow5Situation: "Tanpa penulis",
    apaRow5Format: '("Title," Year)',
    apaRow5Example: '("Study Results," 2024)',
    apaReferenceHeading: "Contoh Daftar Referensi",
    apaBookExample:
      "Author, A. A. (Year). *Title of work: Capital letter also for subtitle*. Publisher. https://doi.org/xxxxx",
    apaJournalExample:
      "Author, A. A., & Author, B. B. (Year). Title of article. *Title of Periodical, Volume*(Issue), Page–Page. https://doi.org/xxxxx",
    apaWebsiteExample:
      "Author, A. A. (Year, Month Day). *Title of page*. Site Name. https://www.example.com/page",
    apaChapterLabel: "Bab Buku yang Disunting",
    apaChapterExample:
      "Author, A. A. (Year). Title of chapter. In E. E. Editor (Ed.), *Title of book* (pp. #–#). Publisher.",
    apaConferenceLabel: "Makalah Konferensi",
    apaConferenceExample:
      "Author, A. A. (Year, Month Days). *Title of paper* [Paper presentation]. Conference Name, Location.",
    apaDifferencesHeading: "Perbedaan Utama dari APA Edisi ke-6",
    apaDifference1: 'Tidak ada "Retrieved from" sebelum URL',
    apaDifference2: "DOI disertakan dalam format tautan https://doi.org/",
    apaDifference3: "Hingga 20 penulis dicantumkan sebelum menggunakan elipsis",
    apaDifference4: "Lokasi penerbit tidak lagi diwajibkan",
    apaDifference5: 'Gunakan "they" tunggal untuk bahasa netral gender',
    apaCtaText: "Buat sitasi APA yang sempurna secara otomatis",
    apaCtaButton: "Pembuat Sitasi APA →",
    mlaMetaTitle: "Lembar Contekan MLA Edisi ke-9 - Panduan Referensi Cepat",
    mlaMetaDescription:
      "Lembar contekan sitasi MLA edisi ke-9 dengan contoh untuk buku, artikel, situs web, dan lainnya. Referensi cepat yang ramah cetak.",
    mlaHeading: "Lembar Contekan MLA Edisi ke-9",
    mlaLead: "Referensi cepat untuk format sitasi MLA yang paling umum.",
    mlaRule1: "Gunakan **indentasi gantung**",
    mlaRule2: "Gunakan spasi ganda untuk semua entri",
    mlaRule3: "Urutkan menurut abjad nama belakang penulis",
    mlaRule4: 'Beri judul halaman "Daftar Karya yang Dikutip"',
    mlaRule5: "Cetak miring judul kontainer (buku, jurnal, situs web)",
    mlaRow1Situation: "1 penulis",
    mlaRow1Format: "(Author Page)",
    mlaRow1Example: "(Smith 45)",
    mlaRow2Situation: "2 penulis",
    mlaRow2Format: "(Author and Author Page)",
    mlaRow2Example: "(Smith and Jones 45)",
    mlaRow3Situation: "3+ penulis",
    mlaRow3Format: "(First Author et al. Page)",
    mlaRow3Example: "(Smith et al. 45)",
    mlaRow4Situation: "Tanpa penulis",
    mlaRow4Format: '("Title" Page)',
    mlaRow4Example: '("Study Results" 45)',
    mlaRow5Situation: "Tanpa nomor halaman",
    mlaRow5Format: "(Author)",
    mlaRow5Example: "(Smith)",
    mlaWorksCitedHeading: "Contoh Daftar Karya yang Dikutip",
    mlaBookExample: "Last, First. *Title of Book*. Publisher, Year.",
    mlaJournalExample:
      'Last, First. "Title of Article." *Journal Title*, vol. #, no. #, Year, pp. #–#.',
    mlaWebsiteExample:
      'Last, First. "Title of Page." *Website Name*, Day Month Year, URL.',
    mlaAnthologyLabel: "Antologi/Buku Suntingan",
    mlaAnthologyExample:
      'Last, First. "Title of Essay." *Title of Collection*, edited by First Last, Publisher, Year, pp. #–#.',
    mlaCoreHeading: "Elemen Inti MLA (berurutan)",
    mlaCore1: "Author.",
    mlaCore2: '"Title of Source."',
    mlaCore3: "*Title of Container*,",
    mlaCore4: "Contributors,",
    mlaCore5: "Version,",
    mlaCore6: "Number,",
    mlaCore7: "Publisher,",
    mlaCore8: "Publication date,",
    mlaCore9: "Location (pages, URL, DOI).",
    mlaCtaText: "Buat sitasi MLA yang sempurna secara otomatis",
    mlaCtaButton: "Pembuat Sitasi MLA →",
    chicagoMetaTitle: "Lembar Contekan Gaya Chicago - Panduan Referensi Cepat",
    chicagoMetaDescription:
      "Lembar contekan sitasi Chicago Manual of Style dengan contoh sistem Catatan-Daftar Pustaka dan Penulis-Tahun. Referensi cepat yang ramah cetak.",
    chicagoHeading: "Lembar Contekan Gaya Chicago",
    chicagoLead:
      "Referensi cepat untuk format sitasi Chicago Manual of Style (edisi ke-18).",
    chicagoSystemsHeading: "Dua Sistem Chicago",
    chicagoColNb: "Catatan-Daftar Pustaka (NB)",
    chicagoColAd: "Penulis-Tahun (AD)",
    chicagoRow1Nb: "Catatan kaki/catatan akhir + daftar pustaka",
    chicagoRow1Ad: "Sitasi dalam tanda kurung + daftar referensi",
    chicagoRow2Nb: "Sejarah, seni, humaniora",
    chicagoRow2Ad: "Sains, ilmu sosial",
    chicagoRow3Nb: "Catatan pertama lebih rinci",
    chicagoRow3Ad: "Mirip dengan format APA",
    chicagoExamplesHeading: "Contoh Catatan-Daftar Pustaka",
    chicagoNoteLabel: "Catatan:",
    chicagoBibliographyLabel: "Daftar Pustaka:",
    chicagoBookLabel: "Buku (Catatan Kaki)",
    chicagoBookNote: "1. First Last, *Title of Book* (Publisher, Year), page.",
    chicagoBookBibliography: "Last, First. *Title of Book*. Publisher, Year.",
    chicagoJournalLabel: "Artikel Jurnal (Catatan Kaki)",
    chicagoJournalNote:
      '1. First Last, "Title of Article," *Journal Title* Vol, no. Issue (Year): pages.',
    chicagoJournalBibliography:
      'Last, First. "Title of Article." *Journal Title* Vol, no. Issue (Year): pages.',
    chicagoWebsiteLabel: "Situs Web (Catatan Kaki)",
    chicagoWebsiteNote:
      '1. First Last, "Title of Page," Site Name, Month Day, Year, URL.',
    chicagoWebsiteBibliography:
      'Last, First. "Title of Page." Site Name. Month Day, Year. URL.',
    chicagoShortHeading: "Catatan Singkat",
    chicagoShortIntro:
      "Setelah sitasi lengkap pertama, gunakan catatan kaki singkat:",
    chicagoShortExample: "1. Last, *Short Title*, page.",
    chicagoRulesHeading: "Aturan Format Utama",
    chicagoRule1:
      "Gunakan angka superskrip untuk rujukan catatan kaki dalam teks",
    chicagoRule2: "Entri daftar pustaka menggunakan indentasi gantung",
    chicagoRule3:
      'Gunakan catatan singkat, bukan "Ibid.", untuk sitasi berurutan dari sumber yang sama',
    chicagoRule4:
      "Judul: buku dan jurnal dicetak miring, artikel dan bab diberi tanda kutip",
    chicagoRule5:
      "Cantumkan tanggal akses untuk sumber daring yang mungkin berubah",
    chicagoCtaText: "Buat sitasi Chicago yang sempurna secara otomatis",
    chicagoCtaButton: "Pembuat Sitasi Chicago →",
  },

  // The catalog's page-type labels (`CATALOG_TYPE_LABELS`), which the search page shows
  // as facet chips and beside every result. Layer 2: a fact from `src/lib/**` rather
  // than page chrome, and English until it is mapped through here.
  catalogTypes: {
    core: "Halaman inti",
    styleLanding: "Hub gaya sitasi utama",
    style: "Halaman referensi gaya sitasi",
    styleExamples: "Halaman contoh sitasi",
    styleFormat: "Panduan format makalah",
    styleInText: "Panduan sitasi dalam teks",
    styleAnnotatedBibliography: "Panduan daftar pustaka beranotasi",
    styleReferencePage: "Panduan halaman referensi/daftar karya yang dikutip",
    tool: "Alat menulis & sitasi gratis",
    guide: "Panduan edukasi",
    guideCategory: "Kategori panduan",
    toolCollection: "Koleksi alat",
    howToCite: "Cara menyitasi <sumber> dengan <gaya>",
    comparison: "Perbandingan gaya sitasi",
    converter: "Konverter pengenal & format",
    field: "Gaya sitasi menurut bidang akademik",
    region: "Gaya sitasi menurut negara/wilayah",
    category: "Gaya sitasi menurut kategori subjek",
    cheatSheet: "Lembar contekan satu halaman",
    glossary: "Glosarium sitasi dan penulisan akademik",
  },

  // /about
  aboutPage: {
    metaTitle: "Tentang CitationEasy - Pembuat Sitasi Gratis",
    metaDescription:
      "CitationEasy adalah pembuat sitasi gratis yang mendukung {count} gaya. Dibuat oleh Samuel Sergi menggunakan alat open source seperti Citation Style Language, Citation.js, dan Next.js.",
    backLink: "← Kembali ke Pembuat Sitasi",
    heading: "Tentang CitationEasy",
    intro:
      "CitationEasy adalah pembuat sitasi gratis dan terbuka untuk mahasiswa, peneliti, dan penulis akademik. Aplikasi ini mendukung **{count} gaya sitasi** dan menyediakan koleksi alat menulis, panduan edukasi, dan sumber daya referensi yang terus bertambah — semuanya tanpa perlu mendaftar atau berlangganan.",
    offerHeading: "Yang Kami Tawarkan",
    offer1:
      "[Pembuat sitasi](/) dengan {count} gaya termasuk APA edisi ke-7, MLA edisi ke-9, Chicago edisi ke-18, Harvard, Vancouver, IEEE, dan ribuan lainnya",
    offer2:
      "[40 alat menulis dan sitasi gratis](/tools) — penghitung kata, pemeriksa keterbacaan, validator DOI, penyusun daftar pustaka menurut abjad, dan lainnya",
    offer3:
      "[750 panduan cara menyitasi](/how-to-cite) yang mencakup setiap jenis sumber utama di 6 gaya sitasi",
    offer4:
      "[100+ panduan edukasi](/guides) tentang praktik terbaik sitasi, penulisan akademik, dan keterampilan riset",
    offer5:
      "[Alat perbandingan gaya](/compare), [kuis gaya sitasi](/quiz), dan [lembar contekan](/cheat-sheets) untuk referensi cepat",
    offer6:
      "7 format ekspor: teks biasa, BibTeX, Word, daftar bernomor, daftar berpoin, RIS, dan CSV",
    openSourceHeading: "Dibangun dengan Open Source",
    openSourceIntro:
      "CitationEasy dimungkinkan berkat sejumlah proyek dan API open source yang luar biasa. Kami percaya pentingnya memberi kredit kepada yang berhak:",
    openSource1:
      "[Citation Style Language (CSL)](https://citationstyles.org/) — standar terbuka yang menjadi dasar {count} gaya sitasi kami. CSL dikelola oleh komunitas sukarelawan dan digunakan oleh pengelola referensi seperti Zotero, Mendeley, dan Papers. Definisi gaya berasal dari [Repositori Gaya CSL](https://github.com/citation-style-language/styles) di GitHub.",
    openSource2:
      "[Citation.js](https://citation.js.org/) — pustaka JavaScript yang memproses sitasi dan memformatnya sesuai gaya CSL. Dibuat oleh Lars Willighagen.",
    openSource3:
      "[Open Library API](https://openlibrary.org/developers/api) — API pencarian buku gratis dari Internet Archive, digunakan untuk mencari metadata buku berdasarkan judul atau ISBN.",
    openSource4:
      "[DOI Foundation](https://www.doi.org/) — sistem Digital Object Identifier yang digunakan untuk menyelesaikan dan memvalidasi DOI.",
    createdHeading: "Dibuat Oleh",
    createdBody:
      "CitationEasy dibuat dan dikelola oleh **Samuel Sergi**. Tujuannya sederhana: menyediakan alat sitasi yang benar-benar gratis dan berkualitas tinggi, tanpa mengunci fitur di balik paywall atau mewajibkan akun.",
    contactPrompt: "Ada pertanyaan, masukan, atau saran? Hubungi kami:",
    contactEmail: "Email: [sam@sammysergi.com](mailto:sam@sammysergi.com)",
    missionHeading: "Misi Kami",
    mission1:
      "Sitasi yang akurat seharusnya tidak berbayar. Banyak alat sitasi mengiklankan diri sebagai gratis tetapi membatasi format ekspor, jumlah sitasi, atau mendorong pengguna ke paket premium. CitationEasy berkomitmen untuk selalu sepenuhnya gratis — tanpa pendaftaran, tanpa batasan, tanpa tingkatan premium.",
    mission2:
      "Setiap fitur di situs ini, mulai dari pembuat sitasi hingga alat menulis dan panduan edukasi, tersedia gratis untuk semua orang. Kami percaya bahwa alat integritas akademik harus dapat diakses oleh semua mahasiswa dan peneliti, apa pun anggaran mereka.",
  },

  // /contact
  contactPage: {
    metaTitle: "Hubungi Kami",
    metaDescription:
      "Hubungi CitationEasy. Ada pertanyaan, masukan, atau saran tentang pembuat sitasi dan alat menulis gratis kami? Kami senang mendengarnya.",
    backLink: "← Kembali ke Pembuat Sitasi",
    heading: "Hubungi Kami",
    intro:
      "Ada pertanyaan, masukan, atau saran tentang CitationEasy? Kami senang mendengarnya. Baik Anda menemukan bug, punya permintaan fitur, atau butuh bantuan dengan sitasi, jangan ragu untuk menghubungi kami.",
    touchHeading: "Hubungi Kami",
    touchBody:
      "Cara terbaik menghubungi kami adalah lewat email. Kami berusaha merespons dalam 48 jam.",
    emailLine: "**Email:** [sam@sammysergi.com](mailto:sam@sammysergi.com)",
    commonHeading: "Pertanyaan Umum",
    commonIntro:
      "Sebelum menghubungi kami, Anda mungkin bisa menemukan jawabannya di salah satu sumber daya berikut:",
    resource1:
      "[Panduan sitasi](/guides) — instruksi langkah demi langkah untuk menyitasi sumber dalam setiap gaya utama",
    resource2:
      "[Panduan cara menyitasi](/how-to-cite) — 750 kombinasi jenis sumber dan gaya beserta contohnya",
    resource3:
      "[Lembar contekan](/cheat-sheets) — referensi cepat untuk format APA, MLA, dan Chicago",
    resource4:
      "[Alat menulis](/tools) — penghitung kata, pemeriksa keterbacaan, validator DOI, dan lainnya",
    issueHeading: "Laporkan Masalah",
    issueIntro:
      "Jika Anda menemukan kesalahan format sitasi, fitur yang rusak, atau gaya yang salah, sertakan detail sebanyak mungkin saat menghubungi kami:",
    issue1: "Gaya sitasi yang Anda gunakan",
    issue2: "Jenis sumber (buku, situs web, artikel jurnal, dll.)",
    issue3: "Apa yang Anda harapkan dibandingkan dengan apa yang dihasilkan",
    issue4: "Browser dan perangkat Anda (jika relevan)",
    issueOutro:
      "Ini membantu kami mengidentifikasi dan memperbaiki masalah dengan cepat.",
    aboutHeading: "Tentang CitationEasy",
    aboutBody:
      "CitationEasy adalah pembuat sitasi gratis yang mendukung lebih dari 10.000 gaya sitasi. Dibuat oleh Samuel Sergi dengan tujuan membuat sitasi akurat dapat diakses oleh semua orang. Pelajari lebih lanjut di [halaman Tentang](/about) kami.",
  },

  // /ai — the agent and developer docs.
  //
  // The code samples, endpoint paths and MCP tool NAMES are deliberately absent: they are
  // the API's identifiers, served in English by the API itself, and a translated one
  // would document an endpoint that does not exist.
  aiPage: {
    metaTitle:
      "CitationEasy untuk Asisten & Agen AI - API, Server MCP, llms.txt",
    metaDescription:
      "Gunakan CitationEasy secara terprogram: API JSON gratis tanpa autentikasi untuk sitasi dalam {count} gaya, server MCP untuk agen, llms.txt, spesifikasi OpenAPI, dan tampilan markdown setiap halaman.",
    keyword1: "API sitasi",
    keyword2: "server MCP",
    keyword3: "API pembuat sitasi",
    keyword4: "llms.txt",
    keyword5: "OpenAPI",
    keyword6: "sitasi agen AI",
    keyword7: "API sitasi gratis",
    webApiDescription:
      "API JSON gratis tanpa autentikasi yang memformat sitasi dalam {count} gaya Citation Style Language dari URL, DOI, ISBN, PubMed ID, arXiv ID, atau metadata CSL-JSON.",
    breadcrumb: "Untuk AI & agen",
    heading: "CitationEasy untuk asisten dan agen AI",
    intro:
      "Semua yang ada di situs ini tersedia untuk perangkat lunak maupun manusia: API JSON gratis, server MCP, spesifikasi OpenAPI, indeks llms.txt, dan tampilan markdown dari semua {count} halaman. Tanpa kunci, tanpa akun, tanpa batas laju kami sendiri.",
    whyHeading: "Mengapa memanggil API alih-alih menulis sitasi sendiri",
    whyBody:
      "Pemformatan sitasi tampak seperti masalah pembuatan teks, padahal bukan. Setiap gaya menyandikan ratusan aturan tentang pembalikan nama penulis, inisial, kapitalisasi judul, tanda baca kontainer, pernyataan edisi, dan penempatan tanggal, dan aturan-aturan ini berbeda dengan cara yang mudah salah secara halus jika mengandalkan ingatan. CitationEasy menjalankan **citeproc-js** terhadap definisi resmi Citation Style Language — mesin yang sama yang digunakan Zotero dan Mendeley — sehingga hasilnya deterministik dan sesuai dengan yang diharapkan sistem pengajuan jurnal. Metadata berasal dari Crossref, Open Library, dan PubMed; tidak ada yang direka-reka, dan bidang yang tidak ada di sumber tetap tidak ada, bukannya diisi dengan tebakan yang masuk akal.",
    generateHeading: "Buat sitasi",
    generateBody:
      "Kirim `inputs` alih-alih `input` untuk hingga 10 sumber dalam satu panggilan, atau `entry` dengan metadata CSL-JSON yang sudah Anda miliki untuk melewati pencarian sepenuhnya. Tambahkan `note: true` untuk bentuk catatan kaki. Kegagalan per sumber dikembalikan pada sumber tersebut, sehingga satu batch tidak pernah gagal secara keseluruhan.",
    mcpHeading: "Terhubung lewat MCP",
    mcpIntro:
      "Endpoint Model Context Protocol di `/api/mcp` menggunakan JSON-RPC 2.0 lewat streamable HTTP dan tidak memerlukan kredensial.",
    mcpToolsHeading: "Tools yang disediakannya",
    endpointsHeading: "Endpoint",
    colEndpoint: "Endpoint",
    colWhat: "Fungsinya",
    endpointCite:
      "Memformat hingga 10 sumber sekaligus. Menerima URL, DOI, ISBN, PubMed ID, arXiv ID, teks BibTeX/RIS/CSL-JSON, atau objek entri CSL-JSON. Mengembalikan entri referensi, dan secara opsional sitasi dalam teks serta catatan kaki.",
    endpointStyles:
      "Cari semua {count} gaya menurut nama, kelas format sitasi, disiplin ilmu, atau wilayah.",
    endpointStyleSlug:
      "Satu gaya secara lengkap, dengan contoh terformat nyata yang dihasilkan dari definisi CSL-nya sendiri.",
    endpointSearch: "Pencarian berperingkat relevansi di semua halaman situs.",
    endpointPages:
      "Katalog situs lengkap sebagai entri terstruktur, dapat difilter menurut jenis halaman.",
    endpointHowToCite:
      "Setiap halaman panduan jenis sumber × gaya, dapat difilter menurut keduanya.",
    endpointTools: "Setiap alat gratis, beserta kategori dan kata kuncinya.",
    endpointGuides: "Setiap panduan edukasi, beserta kategorinya.",
    endpointConverters:
      "Setiap konversi pengenal dan format yang ditawarkan situs.",
    endpointComparisons:
      "Perbandingan gaya berdampingan, ditautkan ke data kedua gaya.",
    endpointFields:
      'Bidang akademik, kategori subjek, dan wilayah — untuk menjawab "gaya apa yang harus saya gunakan?".',
    endpointFaq:
      "Jawaban terverifikasi untuk pertanyaan sitasi umum, dapat difilter dengan q.",
    endpointGlossary:
      "Istilah sitasi dan penulisan akademik beserta definisi lengkapnya — respons membawa teksnya sendiri, jadi tidak ada halaman yang perlu diambil setelahnya.",
    endpointIndex:
      "Dokumen penemuan endpoint. Mulai di sini jika Anda sedang menjelajah.",
    discoveryHeading: "Berkas penemuan",
    discoveryLlms: "Indeks situs terkurasi yang ditulis untuk model bahasa.",
    discoveryLlmsFull:
      "Setiap halaman yang dipublikasikan situs, dikelompokkan menurut jenis, satu baris masing-masing.",
    discoveryOpenapi: "Deskripsi OpenAPI 3.1 dari seluruh API publik.",
    discoveryMcp:
      "Endpoint MCP (streamable HTTP). GET di browser untuk melihat deskripsinya.",
    discoveryWellKnownMcp:
      "Dokumen penemuan MCP untuk agen yang memeriksa sebuah domain.",
    discoveryAiPlugin:
      "Manifes plugin lama, untuk framework yang masih mencarinya.",
    discoveryMd: "Tampilan markdown dari halaman mana pun di situs.",
    discoverySitemap: "Setiap URL yang dapat diindeks.",
    catalogHeading: "Apa saja yang ada di katalog",
    catalogIntro:
      "Setiap halaman di bawah ini dapat diakses sebagai HTML, sebagai markdown di bawah `/md/`, dan sebagai entri terstruktur dari `/api/v1/pages`.",
    catalogStyles:
      "**{count}** gaya sitasi, masing-masing dengan contoh nyata yang dihasilkan dari definisi CSL-nya sendiri",
    catalogTools: "**{count}** alat browser gratis",
    catalogGuides: "**{count}** panduan edukasi",
    catalogHowToCite: "**{count}** halaman cara menyitasi",
    catalogComparisons: "**{count}** perbandingan gaya",
    catalogConverters: "**{count}** konverter",
    catalogFields: "**{count}** bidang akademik",
    catalogStyleLandings:
      "**{count}** hub gaya utama dengan aturan format lengkap",
    faqHeading: "Pertanyaan yang Sering Diajukan",
    faqFreeQ:
      "Apakah API CitationEasy gratis, dan apakah saya butuh kunci API?",
    faqFreeA:
      "API ini gratis dan tidak memerlukan kunci API. Setiap endpoint di bawah /api/v1 tanpa autentikasi dan terbuka untuk CORS, sehingga Anda bisa memanggilnya dari browser, notebook, atau agen tanpa mendaftar. Tidak ada batas laju kami sendiri, tetapi pencarian pengenal diproksikan ke Crossref, Open Library, dan PubMed, yang menerapkan batas penggunaan wajar mereka sendiri — gunakan `inputs` untuk pemrosesan batch alih-alih mengirim banyak permintaan paralel.",
    faqLlmQ: "Apakah sitasinya dihasilkan oleh model bahasa?",
    faqLlmA:
      "Tidak. Pemformatan dijalankan oleh citeproc-js terhadap definisi resmi Citation Style Language, mesin yang sama yang digunakan pengelola referensi. Input dan gaya yang sama selalu menghasilkan string yang sama. Metadata bibliografi berasal dari Crossref (DOI), Open Library (ISBN), dan PubMed (PMID) — CitationEasy tidak merekayasa bidang, jadi apa pun yang tidak ada di sumber juga tidak ada di hasilnya, bukannya ditebak.",
    faqMcpQ: "Bagaimana cara menghubungkan agen ke CitationEasy lewat MCP?",
    faqMcpA:
      "Arahkan klien Model Context Protocol mana pun ke https://www.citationeasy.com/api/mcp menggunakan transport streamable HTTP. Tidak perlu kredensial. Di Claude Code: `claude mcp add --transport http citationeasy https://www.citationeasy.com/api/mcp`. Server ini menyediakan tools untuk membuat sitasi, mencari {count} gaya, panduan jenis sumber, pencarian situs, dan membaca halaman mana pun sebagai markdown.",
    faqStylesQ: "Gaya sitasi apa saja yang bisa dihasilkan API?",
    faqStylesA:
      'Semua {count} gaya dalam repositori Citation Style Language, termasuk APA 7, MLA 9, kedua sistem Chicago, Harvard, Vancouver, IEEE, AMA, dan ribuan gaya jurnal individual. Kirim slug gaya di bidang `style`. Slug yang mudah diingat seperti "chicago" dan "harvard" akan diselesaikan ke varian CSL yang benar, dan /api/v1/styles?q= menemukan sisanya.',
    faqLlmsTxtQ: "Apa itu llms.txt dan di mana punya CitationEasy?",
    faqLlmsTxtA:
      "llms.txt adalah indeks teks polos sebuah situs yang ditulis untuk model bahasa, bukan untuk browser. Punya CitationEasy ada di /llms.txt; versi lengkap yang mencantumkan setiap halaman situs ada di /llms-full.txt.",
    faqMarkdownQ:
      "Bisakah saya membaca halaman CitationEasy sebagai markdown alih-alih HTML?",
    faqMarkdownA:
      "Bisa. Tambahkan awalan /md/ ke path situs mana pun — misalnya /md/citation-style/apa atau /md/tools/word-counter. Halaman berbasis data mengembalikan konten lengkapnya, termasuk contoh terformat nyata yang dihasilkan dari definisi CSL masing-masing gaya. Halaman berisi teks tulisan tangan (panduan, lembar contekan) mengembalikan kartu ringkasan plus URL HTML kanonis, karena teksnya hanya ada di halaman itu sendiri.",
    faqReuseQ:
      "Bolehkah saya menggunakan hasil CitationEasy di produk saya sendiri?",
    faqReuseA:
      "Boleh. Sitasi terformat adalah fakta tentang sebuah sumber; gunakan dengan bebas. Definisi gaya CSL itu sendiri berasal dari proyek Citation Style Language di bawah lisensi CC BY-SA 3.0. Atribusi kembali ke CitationEasy dihargai tetapi tidak wajib.",
    missingHeading: "Ada yang kurang?",
    missingBody:
      "Jika agen Anda membutuhkan endpoint, bidang, atau format yang tidak ada di sini, [beri tahu kami](/contact). Menjelajah secara manual? [Mulai dari pembuat sitasi](/).",
  },

  // /quiz. The client component reads these as a prop rather than through a context:
  // it is one component, not the generator's nine, so there is nothing to drill through.
  quizPage: {
    metaTitle: "Gaya Sitasi Apa yang Harus Saya Gunakan? - Kuis Gaya Gratis",
    metaDescription:
      "Jawab beberapa pertanyaan singkat tentang bidang studi, jenis makalah, dan preferensi Anda untuk menemukan gaya sitasi terbaik untuk makalah Anda. APA, MLA, Chicago, Vancouver, dan lainnya.",
    ogTitle: "Gaya Sitasi Apa yang Harus Saya Gunakan?",
    ogDescription:
      "Ikuti kuis gratis kami untuk menemukan gaya sitasi terbaik untuk makalah Anda.",
    breadcrumbHome: "CitationEasy",
    breadcrumbCurrent: "Kuis Gaya",
    backLink: "← Kembali ke Pembuat Sitasi",
    heading: "Gaya Sitasi Apa yang Harus Saya Gunakan?",
    intro:
      "Jawab beberapa pertanyaan singkat dan kami akan merekomendasikan gaya sitasi terbaik untuk makalah Anda.",
    progress: "Pertanyaan {current} dari {total}",
    qDiscipline: "Apa bidang studi Anda?",
    optSocialScience: "Psikologi / Ilmu Sosial",
    optHumanities: "Sastra / Humaniora",
    optHistory: "Sejarah / Sejarah Seni",
    optMedical: "Kedokteran / Keperawatan / Kesehatan",
    optEngineering: "Teknik / Ilmu Komputer",
    optNaturalScience: "Sains Alam (Biologi, Kimia)",
    optLaw: "Hukum",
    optBusiness: "Bisnis / Ekonomi",
    qPaperType: "Jenis makalah apa yang sedang Anda tulis?",
    optResearch: "Makalah penelitian atau tesis",
    optReview: "Tinjauan pustaka",
    optReport: "Laporan laboratorium atau laporan teknis",
    optEssay: "Esai atau tugas kelas",
    optJournal: "Pengajuan artikel jurnal",
    qRegion: "Di mana lokasi institusi Anda?",
    optUs: "Amerika Serikat",
    optUk: "Inggris Raya / Australia",
    optCanada: "Kanada",
    optEurope: "Eropa (di luar Inggris Raya)",
    optOther: "Lainnya",
    qPreference: "Apakah Anda punya preferensi format sitasi?",
    optAuthorDate: "Sitasi dalam teks (Penulis, Tahun)",
    optNumeric: "Referensi bernomor [1]",
    optFootnotes: "Catatan kaki",
    optNoPreference: "Tidak ada preferensi",
    styleVancouver: "Vancouver",
    styleAma:
      "AMA (American Medical Association / Asosiasi Kedokteran Amerika)",
    styleIeee: "IEEE",
    styleBluebook: "Bluebook",
    styleCse: "CSE (Council of Science Editors / Dewan Editor Sains)",
    styleChicagoNotes: "Chicago (Catatan & Daftar Pustaka)",
    styleMla: "MLA (Edisi ke-9)",
    styleApa: "APA (Edisi ke-7)",
    styleHarvard: "Harvard",
    reasonVancouverMedical:
      "Vancouver adalah standar untuk jurnal kedokteran dan ilmu kesehatan, menggunakan referensi bernomor.",
    reasonAma:
      "AMA banyak digunakan di jurnal kedokteran dan menggunakan sitasi bernomor.",
    reasonIeee:
      "IEEE adalah gaya sitasi standar untuk bidang teknik, ilmu komputer, dan TI.",
    reasonBluebook:
      "Bluebook adalah gaya sitasi definitif untuk penulisan hukum. Gaya Chicago adalah alternatif serba guna yang paling mendekati.",
    reasonCse: "CSE adalah standar untuk biologi dan ilmu alam.",
    reasonChicagoHistory:
      "Chicago Catatan & Daftar Pustaka adalah standar emas untuk sejarah dan sejarah seni, menggunakan catatan kaki untuk sitasi.",
    reasonChicagoHumanities:
      "Chicago Catatan & Daftar Pustaka cocok untuk humaniora dengan pendekatan berbasis catatan kakinya.",
    reasonMla: "MLA adalah standar untuk bidang sastra, bahasa, dan humaniora.",
    reasonApaBusiness:
      "APA banyak digunakan di bidang bisnis, ekonomi, dan manajemen.",
    reasonHarvard:
      "Referensi Harvard adalah gaya paling umum di universitas Inggris Raya dan Australia.",
    reasonChicagoFootnotes:
      "Chicago Catatan & Daftar Pustaka menggunakan catatan kaki, ideal untuk sitasi yang rinci.",
    reasonVancouverNumeric:
      "Vancouver menggunakan sitasi bernomor, membuat teks Anda rapi dan mudah dibaca.",
    reasonApaDefault:
      "APA adalah gaya sitasi yang paling banyak digunakan di ilmu sosial, pendidikan, dan banyak disiplin ilmu lainnya.",
    recommendLabel: "Kami merekomendasikan",
    generateButton: "Buat Sitasi {style}",
    retakeButton: "Ulangi Kuis",
    guidesLink: "Jelajahi panduan sitasi kami untuk bantuan lebih lanjut →",
    previousButton: "← Pertanyaan sebelumnya",
  },

  // /search — the server-rendered site search.
  searchPage: {
    metaTitle: "Cari di CitationEasy",
    metaDescription:
      "Cari semua halaman di CitationEasy sekaligus: {count} gaya sitasi, 250+ alat gratis, panduan, halaman cara menyitasi, perbandingan gaya, konverter, dan glosarium.",
    keyword1: "cari gaya sitasi",
    keyword2: "temukan panduan sitasi",
    keyword3: "cari alat sitasi",
    ogDescription:
      "Cari semua halaman di situs sekaligus — gaya, alat, panduan, halaman cara menyitasi, perbandingan, konverter, dan istilah glosarium.",
    ogImageSubtitle:
      "Semua gaya sitasi, alat, panduan, halaman cara menyitasi, perbandingan, konverter, dan istilah glosarium — dicari sekaligus.",
    ogKind: "Pencarian",
    breadcrumb: "Cari",
    heading: "Cari di CitationEasy",
    intro:
      "Semua gaya sitasi, alat, panduan, halaman cara menyitasi, perbandingan, konverter, dan istilah glosarium di situs — dicari sekaligus.",
    inputLabel: "Kata kunci pencarian",
    inputPlaceholder:
      "misalnya: menyitasi podcast dalam APA, indentasi gantung, DOI",
    submit: "Cari",
    browseHeading: "Atau jelajahi menurut bagian",
    browseStyles: "Gaya sitasi",
    browseStylesNote: "{count} gaya",
    browseTools: "Alat gratis",
    browseToolsNote: "{count} alat",
    browseHowTo: "Cara menyitasi sumber apa pun",
    browseHowToNote: "{count} halaman",
    browseGuides: "Panduan",
    browseGuidesNote: "{count} panduan",
    browseGlossary: "Glosarium",
    browseGlossaryNote: "{count} istilah",
    browseComparisons: "Perbandingan gaya",
    browseComparisonsNote: "{count} perbandingan",
    browseConverters: "Konverter",
    browseConvertersNote: "{count} konverter",
    browseCheatSheets: "Lembar contekan",
    browseCheatSheetsNote: "{count} lembar",
    facetsLabel: "Filter menurut jenis halaman",
    facetAll: "Semua ({count})",
    noMatches: "Tidak ada halaman yang cocok dengan “{query}”.",
    matchesOne: "{count} halaman cocok dengan “{query}”.",
    matchesMany: "{count} halaman cocok dengan “{query}”.",
    pagerLabel: "Halaman hasil",
    pagerPrevious: "← Sebelumnya",
    pagerNext: "Berikutnya →",
    pagerPosition: "Halaman {page} dari {total}",
    paletteLoading: "Mencari…",
    paletteError: "Pencarian sedang tidak tersedia. Coba lagi.",
    paletteViewAll: "Lihat semua hasil untuk “{query}”",
    apiNote:
      "Sedang membangun sesuatu? Indeks yang sama tersedia dalam format JSON di [/api/v1/search](/api/v1/search?q=podcast) dan lewat MCP — lihat [dokumentasi agen](/ai).",
  },

  // /cite-this-page. The six FAQ answers used to exist twice — once in the layout for the
  // FAQPage markup and once in the page for the visible list — which is exactly the drift
  // this dictionary removes: both now read the same keys.
  citeThisPage: {
    metaTitle:
      "Sitasi Halaman Ini - Sitasi Satu Klik (Bookmarklet & Ekstensi Chrome)",
    metaDescription:
      "Sitasi halaman web mana pun dengan satu klik. Seret bookmarklet gratis 'Sitasi Halaman Ini' ke bilah bookmark Anda, atau pasang ekstensi Chrome gratis dengan tombol bilah alat dan sitasi lewat klik kanan. Berfungsi juga di Chromebook dan browser yang dibatasi.",
    ogTitle: "Bookmarklet & Ekstensi Chrome Sitasi Halaman Ini",
    ogDescription:
      "Sitasi situs web satu klik dari halaman mana pun — bookmarklet seret-dan-lepas plus ekstensi Chrome gratis dengan sitasi lewat klik kanan.",
    breadcrumbRoot: "CitationEasy",
    breadcrumbSchemaCurrent: "Bookmarklet Sitasi Halaman Ini",
    appName: "Bookmarklet Sitasi Halaman Ini",
    appDescription:
      "Bookmarklet gratis yang menyitasi halaman web yang sedang Anda baca dengan satu klik — bookmarklet ini membuka CitationEasy dengan URL halaman terisi otomatis, lalu memformat sitasi dalam gaya APA, MLA, Chicago, dan {count} gaya lainnya.",
    breadcrumbLabel: "Remah navigasi",
    breadcrumbHome: "Beranda",
    breadcrumbCurrent: "Bookmarklet Sitasi Halaman Ini",
    heading: "Sitasi Halaman Ini: Bookmarklet & Ekstensi Chrome",
    intro:
      "Sitasi halaman web mana pun dengan satu klik — tanpa pendaftaran. Seret bookmarklet di bawah ke bilah bookmark Anda (tanpa instalasi sama sekali), atau ambil ekstensi Chrome gratis untuk tombol bilah alat dan sitasi lewat klik kanan.",
    dragPrompt: "Seret tombol ini ke bilah bookmark Anda:",
    buttonTitle: "Seret saya ke bilah bookmark Anda",
    buttonLabel: "📑 Sitasi Halaman Ini",
    dontClick: "Jangan klik di sini — seret dulu ke bilah bookmark Anda.",
    installHeading: "Cara memasangnya",
    step1Title: "Tampilkan bilah bookmark Anda",
    step1Body:
      "Di sebagian besar browser, tekan Ctrl+Shift+B (Cmd+Shift+B di Mac) untuk menampilkan bilah bookmark agar Anda punya tempat meletakkan tombolnya.",
    step2Title: "Seret tombolnya ke atas",
    step2Body:
      "Klik dan tahan tombol 'Sitasi Halaman Ini' di bawah, lalu seret ke bilah bookmark Anda dan lepaskan. Tombol ini akan menjadi bookmark biasa.",
    step3Title: "Klik pada halaman mana pun",
    step3Body:
      "Saat membaca artikel, berita, atau halaman jurnal, klik bookmark baru Anda. CitationEasy terbuka dengan URL halaman itu terisi otomatis dan sitasinya siap disalin.",
    manualHeading: "Tidak bisa menyeret? Tambahkan secara manual",
    manualBody:
      'Buat bookmark baru, beri nama "Sitasi Halaman Ini", lalu tempel ini sebagai URL/alamatnya:',
    howHeading: "Cara kerjanya",
    howBody:
      "Bookmarklet ini tidak menjalankan kode apa pun di halaman yang sedang Anda baca. Ia hanya mengirimkan alamat web halaman tersebut ke CitationEasy, tempat server kami mengambil dan mengurai metadata halaman publik — jalur tepercaya yang sama seperti saat Anda menempel URL ke pembuat sitasi secara manual. Ini menjaga keamanannya dan menghindari batasan lintas asal yang membuat bookmarklet lama yang berjalan langsung di halaman tidak lagi berfungsi.",
    extensionHeading: "Lebih suka ekstensi Chrome?",
    extensionBody:
      "Ekstensi CitationEasy gratis menambahkan tombol bilah alat yang menyitasi tab saat ini, plus opsi klik kanan untuk menyitasi tautan — atau DOI atau ISBN yang dipilih — tanpa membukanya. Seperti bookmarklet, ekstensi ini tidak menjalankan kode apa pun di halaman yang Anda kunjungi: ia hanya mengirimkan URL ke CitationEasy. Ekstensi ini hanya memerlukan izin `activeTab` dan `contextMenus`, dan berfungsi di Chrome, Edge, Brave, dan browser berbasis Chromium lainnya.",
    downloadButton: "⬇ Unduh ekstensi Chrome (.zip)",
    install1: "Unduh dan ekstrak ekstensinya.",
    install2:
      "Buka `chrome://extensions` dan aktifkan **Mode pengembang** (kanan atas).",
    install3: "Klik **Load unpacked** dan pilih folder yang sudah diekstrak.",
    install4:
      "Sematkan tombol CitationEasy, lalu klik pada halaman mana pun untuk menyitasinya.",
    faqHeading: "Pertanyaan yang Sering Diajukan",
    faqWhatQ: "Apa itu bookmarklet 'Sitasi Halaman Ini'?",
    faqWhatA:
      "Ini adalah bookmark kecil yang Anda seret ke bilah bookmark browser Anda. Saat Anda mengkliknya di halaman web mana pun, ia membuka CitationEasy di tab baru dengan URL halaman itu sudah terisi, sehingga Anda mendapatkan sitasi terformat dengan satu klik — tanpa salin-tempel.",
    faqExtensionNeededQ: "Apakah saya perlu memasang ekstensi?",
    faqExtensionNeededA:
      "Tidak. Bookmarklet hanyalah sebuah bookmark, jadi tidak ada yang perlu dipasang dan tidak ada izin yang perlu diberikan. Ia berfungsi di Chromebook sekolah yang dibatasi dan sebagian besar browser seluler tempat ekstensi diblokir. Jika Anda lebih suka ekstensi, ekstensi Chrome gratis juga tersedia di halaman ini.",
    faqChromeQ: "Apakah ada ekstensi Chrome?",
    faqChromeA:
      "Ya. Ekstensi Chrome CitationEasy gratis menambahkan tombol bilah alat yang menyitasi tab saat ini, plus opsi klik kanan untuk menyitasi tautan atau DOI/ISBN yang dipilih tanpa membukanya. Ekstensi ini tidak menjalankan kode apa pun di halaman yang Anda kunjungi dan hanya memerlukan izin activeTab dan contextMenus. Unduh dari halaman ini dan muat lewat chrome://extensions — ekstensi ini berfungsi di Chrome, Edge, Brave, dan browser berbasis Chromium lainnya.",
    faqAddQ: "Bagaimana cara menambahkan bookmarkletnya?",
    faqAddA:
      "Pastikan bilah bookmark Anda terlihat, lalu seret tombol 'Sitasi Halaman Ini' pada halaman ini ke sana. Jika menyeret tidak memungkinkan (misalnya di perangkat seluler), buat bookmark baru secara manual dan tempel kode bookmarklet sebagai URL-nya.",
    faqSafeQ: "Apakah ini aman? Apakah ia membaca halaman tempat saya berada?",
    faqSafeA:
      "Ya, ini aman. Bookmarklet tidak menjalankan kode apa pun di halaman yang sedang Anda baca — ia hanya mengirimkan alamat web halaman itu ke CitationEasy, tempat server kami mengambil dan mengurai metadata halaman publik, persis seperti saat Anda menempel URL secara manual.",
    faqOtherSourcesQ: "Apakah ini berfungsi untuk sumber selain situs web?",
    faqOtherSourcesA:
      "Bookmarklet ini untuk halaman web, tetapi tautan yang mendasarinya juga menerima DOI, ISBN, PMID, atau ID arXiv lewat parameter ?source= — jadi tautan 'sitasi ini' yang dapat dibagikan juga berfungsi untuk artikel jurnal dan buku.",
    relatedHeading: "Alat Terkait",
    relatedGenerator: "Pembuat Sitasi",
    relatedHowToCite: "Cara Menyitasi Situs Web",
    relatedTools: "Semua Alat",
  },

  // /shared-bibliography — opens a bibliography that travelled inside a share link.
  sharedBibliographyPage: {
    metaTitle: "Daftar Pustaka yang Dibagikan - Lihat & Impor Sitasi",
    metaDescription:
      "Buka daftar pustaka yang dibagikan seseorang kepada Anda dari CitationEasy. Lihat sitasi yang sudah diformat, salin, atau impor seluruh daftar ke daftar pustaka Anda sendiri — gratis, tanpa akun, dan datanya tersimpan langsung di dalam tautannya.",
    ogTitle: "Daftar Pustaka yang Dibagikan",
    ogDescription:
      "Lihat dan impor daftar pustaka yang dibagikan. Sitasi tersimpan di dalam tautan itu sendiri — tidak ada yang disimpan di server, dan tautannya tidak pernah kedaluwarsa.",
    breadcrumbRoot: "CitationEasy",
    breadcrumbLabel: "Remah navigasi",
    breadcrumbHome: "Beranda",
    breadcrumbCurrent: "Daftar Pustaka yang Dibagikan",
    heading: "Daftar Pustaka yang Dibagikan",
    intro:
      "Seseorang membagikan sitasi ini kepada Anda. Salin, atau impor seluruh daftar ke daftar pustaka CitationEasy Anda sendiri dengan satu klik.",
    loading: "Membuka daftar pustaka yang dibagikan…",
    copyAll: "Salin semua",
    copied: "Tersalin",
    copyFailed: "Gagal menyalin",
    citationOne: "sitasi",
    citationMany: "sitasi",
    addAll: "Tambahkan semua ke daftar pustaka saya",
    added: "{count} ditambahkan ke daftar pustaka Anda",
    skippedOne: "{count} duplikat dilewati",
    skippedMany: "{count} duplikat dilewati",
    openGenerator: "buka pembuat sitasi",
    emptyHeading: "Tidak ada daftar pustaka yang dibagikan di tautan ini",
    emptyBody:
      "Halaman ini menampilkan daftar pustaka yang dibagikan dari CitationEasy. Untuk membagikan milik Anda, buka daftar pustaka Anda di [pembuat sitasi](/), pilih **Ekspor → Salin tautan berbagi**, lalu kirim tautannya ke siapa saja. Sitasi tersimpan di dalam tautan itu sendiri — tidak ada yang disimpan di server, jadi tautannya tetap berfungsi selamanya dan data Anda tetap privat.",
    decodeError: "Tautan berbagi ini tidak dapat dibuka.",
  },

  // The 19 source types the 15 detailed styles show worked examples for
  // (`DetailedStyleData.examples[].sourceType`). 75 rows, 19 distinct values — so this
  // is a vocabulary, not per-page copy, and it belongs here rather than repeated in
  // every locale's `src/content/style-pages/<locale>.json`.
  //
  // Two casings for the same reason `howToCitePage.refList*Lower` has two: the pages
  // print the label as a heading ("Book") and inside a sentence ("a sample APA entry
  // for a book"). Lower-casing the translated noun in code is wrong in German, where
  // every one of these is capitalised, so the lower form is a real key a translator
  // fills rather than a `.toLowerCase()` call.
  //
  // The citations themselves — `referenceEntry` and `inTextCitation` — are NOT here and
  // are not translatable anywhere: they are worked examples in a specific style's own
  // punctuation. See `src/lib/localized-content.ts`.
  sourceTypes: {
    book: "Buku",
    bookLower: "buku",
    bookChapter: "Bab Buku",
    bookChapterLower: "bab buku",
    case: "Perkara",
    caseLower: "perkara",
    conferencePaper: "Makalah Konferensi",
    conferencePaperLower: "makalah konferensi",
    courtCase: "Kasus Pengadilan",
    courtCaseLower: "kasus pengadilan",
    federalStatute: "Undang-Undang Federal",
    federalStatuteLower: "undang-undang federal",
    governmentDocument: "Dokumen Pemerintah",
    governmentDocumentLower: "dokumen pemerintah",
    governmentReport: "Laporan Pemerintah",
    governmentReportLower: "laporan pemerintah",
    journalArticle: "Artikel Jurnal",
    journalArticleLower: "artikel jurnal",
    lawReviewArticle: "Artikel Jurnal Hukum",
    lawReviewArticleLower: "artikel jurnal hukum",
    legislation: "Peraturan Perundang-undangan",
    legislationLower: "peraturan perundang-undangan",
    newspaperArticle: "Artikel Surat Kabar",
    newspaperArticleLower: "artikel surat kabar",
    patent: "Paten",
    patentLower: "paten",
    podcast: "Podcast",
    podcastLower: "podcast",
    preprint: "Preprint",
    preprintLower: "preprint",
    standard: "Standar",
    standardLower: "standar",
    thesis: "Tesis",
    thesisLower: "tesis",
    website: "Situs Web",
    websiteLower: "situs web",
    youtubeVideo: "Video YouTube",
    youtubeVideoLower: "video YouTube",
  },

  // Chrome shared by the five per-style guide routes — /examples, /format,
  // /in-text-citation, /reference-page and /annotated-bibliography, 15 styles each.
  //
  // One section rather than five copies: the CTA, the back link and the cross-links
  // between the five pages are the same sentences on every one of them, and duplicating
  // them per route would be five identical translation units instead of one.
  styleGuidePages: {
    backToStyle: "Kembali ke {style}",
    backToGenerator: "Kembali ke Pembuat Sitasi",
    ctaHeading: "Buat Sitasi {style} Secara Otomatis",
    ctaButton: "Sitasi dengan {style} Sekarang →",
    faqHeading: "Pertanyaan yang Sering Diajukan",
    resourcesHeading: "Sumber Daya Lainnya",
    relatedHeading: "Panduan {style} Terkait",
    resourceGenerator: "Pembuat Sitasi Gratis ({count} gaya)",
    resourceTools: "Alat Menulis Gratis",
    resourceGuides: "Semua Panduan Sitasi",
    resourceStyleGenerator: "Pembuat Sitasi {style}",
    resourceExamples: "Contoh Sitasi {style}",
    resourceFormat: "Panduan Format {style}",
    resourceInText: "Panduan Sitasi Dalam Teks {style}",
    resourceAnnotatedBib: "Panduan Daftar Pustaka Beranotasi {style}",
    resourceReferencePage: "Panduan {list} {style}",
    notFoundTitle: "Tidak Ditemukan",
  },

  // /examples/<style> — the copy-ready worked examples for all 15 detailed styles.
  examplesPage: {
    metaTitle: "Contoh Sitasi {style} - Semua Jenis Sumber [2026]",
    metaDescription:
      "Lihat contoh sitasi {style} ({edition}) yang sudah diformat untuk buku, artikel jurnal, situs web, dan lainnya. Entri {list} dan sitasi dalam teks siap salin.",
    ogTitle: "Contoh sitasi {style}",
    ogDescription: "Entri {style} siap salin untuk setiap jenis sumber umum.",
    ogImageTitle: "Contoh Sitasi {style}",
    ogKind: "{style} {edition}",
    keywordExamples: "contoh sitasi {style}",
    keywordReference: "contoh referensi {style}",
    keywordInText: "contoh sitasi dalam teks {style}",
    keywordList: "contoh {listLower} {style}",
    keywordHowTo: "cara menyitasi dengan {style}",
    breadcrumb: "Contoh Sitasi {style}",
    heading: "Contoh Sitasi {style}",
    lead: "Lihat contoh sitasi {style} ({edition}) yang diformat dengan benar untuk {count} jenis sumber umum. Setiap contoh mencakup entri {listLower} dan sitasi dalam teks yang sesuai.",
    entryLabel: "Entri {list}:",
    inTextLabel: "Sitasi Dalam Teks:",
    ctaBody:
      "Lewati pemformatan manual. Tempel DOI, URL, atau ISBN ke CitationEasy dan dapatkan sitasi {style} yang terformat sempurna dalam hitungan detik.",
    faqLookQ: "Seperti apa bentuk sitasi {style}?",
    faqLookA:
      "Sitasi {style} terdiri dari entri {listLower} dengan detail sumber lengkap dan sitasi dalam teks. Formatnya berbeda-beda menurut jenis sumber. Misalnya, sitasi buku dalam {style} ({edition}) mencakup penulis, tahun, judul, dan penerbit.",
    faqHowManyQ: "Berapa banyak contoh sitasi {style} yang tersedia?",
    faqHowManyA:
      "CitationEasy menyediakan contoh sitasi {style} untuk {count} jenis sumber, termasuk {types}. Setiap contoh mencakup entri {listLower} dan sitasi dalam teks yang sesuai.",
    faqCopyQ: "Bolehkah saya menyalin contoh sitasi {style} ini?",
    faqCopyA:
      "Ya, contoh {style} pada halaman ini menunjukkan format yang tepat untuk setiap jenis sumber. Anda dapat menggunakannya sebagai templat untuk sitasi Anda sendiri. Untuk pemformatan otomatis, gunakan pembuat sitasi {style} gratis kami.",
  },

  // /format/<style> — font, margins, spacing, title page and headers. The VALUES those
  // labels take are per-style prose and live in the overlay, not here.
  formatPage: {
    metaTitle: "Panduan Format {style} - Aturan Format Makalah [2026]",
    metaDescription:
      "Panduan lengkap format makalah {style} ({edition}). Pelajari font, margin, spasi, halaman judul, header, dan aturan format {listLower} yang benar.",
    ogTitle: "Format makalah {style}",
    ogDescription:
      "Margin, font, spasi, dan halaman judul untuk makalah {style}.",
    ogImageTitle: "Format Makalah {style}",
    ogImageSubtitle: "margin {margins} · {spacing}",
    ogKind: "{style} {edition}",
    keywordFormat: "format {style}",
    keywordPaperFormat: "format makalah {style}",
    keywordRules: "aturan format {style}",
    keywordMargins: "margin font spasi {style}",
    keywordList: "format {listLower} {style}",
    breadcrumb: "Panduan Format {style}",
    heading: "Panduan Format {style}",
    lead: "Ikuti aturan format makalah {style} ({edition}) berikut agar dokumen Anda memenuhi standar yang diwajibkan. Panduan ini mencakup font, margin, spasi, halaman judul, header, dan format {listLower}.",
    paperHeading: "Format Makalah",
    paperIntro:
      "Berikut adalah persyaratan format inti untuk makalah yang ditulis dengan gaya {style} ({edition}).",
    labelFont: "Font",
    labelFontSize: "Ukuran Font",
    labelMargins: "Margin",
    labelSpacing: "Spasi",
    labelTitlePage: "Halaman Judul",
    labelHeaders: "Header / Nomor Halaman",
    listHeading: "Format {list}",
    listIntro:
      "{listLower} Anda harus mengikuti aturan berikut agar terformat dengan benar dalam gaya {style}:",
    ctaBody:
      "Biarkan CitationEasy yang menangani formatnya. Tempel DOI, URL, atau ISBN dan dapatkan sitasi {style} yang terformat sempurna dalam hitungan detik.",
    faqFontQ:
      "Font dan ukuran apa yang harus saya gunakan untuk format {style}?",
    faqFontA:
      "{style} ({edition}) mewajibkan {font}. Ukuran font standarnya adalah {fontSize}.",
    faqMarginsQ: "Apa persyaratan margin untuk {style}?",
    faqMarginsA:
      "Makalah {style} mewajibkan margin {margins}. Ini berlaku untuk margin atas, bawah, kiri, dan kanan di setiap halaman.",
    faqTitlePageQ: "Apakah {style} mewajibkan halaman judul?",
  },

  // /in-text-citation/<style> — the six in-text forms. The forms themselves
  // ("(Smith, 2024)") are per-style prose in the overlay.
  inTextCitationPage: {
    metaTitle: "Panduan Sitasi Dalam Teks {style} - Aturan & Contoh [2026]",
    metaDescription:
      "Pelajari cara memformat sitasi dalam teks {style} ({edition}). Aturan untuk satu penulis, banyak penulis, kutipan langsung, tanpa penulis, dan tanpa tanggal beserta contohnya.",
    ogTitle: "Sitasi dalam teks {style}",
    ogDescription: "Semua bentuk sitasi dalam teks {style}, dengan contoh.",
    ogImageTitle: "Sitasi Dalam Teks {style}",
    ogImageSubtitle:
      "Satu penulis {singleAuthor} · tiga atau lebih {threeOrMore}",
    ogKind: "{style} {edition}",
    keywordInText: "sitasi dalam teks {style}",
    keywordExamples: "contoh sitasi dalam teks {style}",
    keywordParenthetical: "sitasi parentetik {style}",
    keywordRules: "aturan sitasi {style}",
    keywordHowTo: "cara menyitasi dalam teks {style}",
    breadcrumb: "Sitasi Dalam Teks {style}",
    heading: "Sitasi Dalam Teks {style}",
    lead: "Kuasai sitasi dalam teks {style} ({edition}) dengan panduan lengkap ini. Pelajari format yang benar untuk setiap skenario, termasuk satu dan banyak penulis, kutipan langsung, dan sumber dengan informasi yang tidak lengkap.",
    rulesHeading: "Aturan Sitasi Dalam Teks",
    rulesIntro:
      "Berikut aturan sitasi dalam teks {style} untuk setiap skenario umum yang akan Anda temui saat menulis makalah.",
    labelSingleAuthor: "Satu Penulis",
    labelTwoAuthors: "Dua Penulis",
    labelThreeOrMore: "Tiga Penulis atau Lebih",
    labelDirectQuote: "Kutipan Langsung",
    labelNoAuthor: "Tanpa Penulis",
    labelNoDate: "Tanpa Tanggal",
    examplesHeading: "Contoh Singkat",
    examplesIntro:
      "Berikut contoh nyata sitasi dalam teks {style} untuk berbagai jenis sumber:",
    ctaBody:
      "Berhenti khawatir soal format sitasi dalam teks. Tempel DOI, URL, atau ISBN ke CitationEasy dan dapatkan entri {listLower} serta sitasi dalam teks secara instan.",
    faqFormatQ: "Bagaimana cara memformat sitasi dalam teks {style}?",
    faqFormatA:
      "Untuk satu penulis dalam {style}, gunakan format {singleAuthor}. Untuk dua penulis, gunakan {twoAuthors}. Untuk tiga penulis atau lebih, gunakan {threeOrMore}.",
    faqQuoteQ: "Bagaimana cara menyitasi kutipan langsung dalam {style}?",
    faqQuoteA:
      "Untuk kutipan langsung dalam {style} ({edition}), gunakan format: {directQuote}.",
    faqMissingQ: "Bagaimana jika tidak ada penulis atau tanggal dalam {style}?",
    faqMissingA:
      "Jika tidak ada penulis dalam {style}, gunakan: {noAuthor}. Jika tidak ada tanggal, gunakan: {noDate}.",
  },

  // /reference-page/<style> — how to build the list at the back of the paper.
  //
  // The five `mistake*` strings carry `**bold**` inline markup because the lead-in of
  // each bullet is emphasised inside the sentence; they render through `InlineText`.
  referenceListPage: {
    metaTitle: "Panduan {list} {style} - Aturan Format [2026]",
    metaDescription:
      "Pelajari cara memformat {listLower} {style} ({edition}). Aturan format langkah demi langkah, contoh, dan kesalahan umum yang harus dihindari untuk {fullName}.",
    ogTitle: "{listLower} {style}",
    ogDescription: "Cara menyusun {list} dalam {style}.",
    ogImageTitle: "{list} {style}",
    ogKind: "{style} {edition}",
    breadcrumb: "Cara Memformat {list} {style}",
    heading: "Cara Memformat {list} {style}",
    lead: "{listLower} adalah salah satu bagian terpenting dari makalah akademik mana pun yang diformat dengan gaya {style} ({edition}). Bagian ini memberi pembaca detail lengkap setiap sumber yang Anda sitasi, sehingga mereka dapat menemukan dan memverifikasi referensi Anda. Memformat dengan benar sangat penting untuk kredibilitas akademik. Panduan ini mencakup aturan yang tepat, menunjukkan contoh nyata, dan menyoroti kesalahan paling umum yang dibuat mahasiswa.",
    rulesHeading: "Aturan Format",
    rulesIntro: "Ikuti aturan berikut saat membuat {listLower} {style} Anda:",
    exampleHeading: "Contoh {list}",
    exampleIntro:
      "Berikut tampilan {listLower} {style} dengan entri untuk berbagai jenis sumber:",
    mistakesHeading: "Kesalahan Umum yang Harus Dihindari",
    mistakesIntro:
      "Berikut lima kesalahan format paling umum yang dibuat mahasiswa saat menyusun {listLower} {style}:",
    mistakeIndent:
      "**Indentasi gantung yang hilang atau salah:** baris pertama setiap entri harus rata kiri, dan semua baris berikutnya diberi indentasi 1,27 cm (0,5 inci). Gunakan pengaturan paragraf pada pengolah kata Anda, bukan menekan tombol Tab.",
    mistakeOrder:
      '**Urutan abjad yang salah:** entri harus disusun menurut aturan {style}. Abaikan kata sandang seperti "A," "An," dan "The" saat mengurutkan menurut abjad. Untuk gaya bernomor, daftar entri sesuai urutan kemunculan pertamanya dalam teks.',
    mistakeSpacing:
      "**Spasi yang tidak konsisten:** periksa kembali spasi baris di seluruh {listLower}. Mencampur spasi tunggal dan ganda adalah kesalahan umum yang mudah terlewat.",
    mistakeItalics:
      "**Penggunaan huruf miring yang salah:** cetak miring judul karya mandiri seperti buku dan jurnal, tetapi jangan cetak miring judul artikel atau bab. Periksa pedoman {style} untuk mengetahui elemen mana saja yang harus dicetak miring.",
    mistakeLinks:
      "**DOI dan URL yang hilang atau rusak:** selalu sertakan DOI jika tersedia, diformat sebagai tautan yang dapat diklik. Uji setiap URL sebelum menyerahkan makalah Anda untuk memastikan tautan tersebut mengarah ke sumber yang benar.",
    ctaHeading: "Buat {list} Anda Secara Otomatis",
    ctaBody:
      "Lewati pemformatan manual. Tempel DOI, URL, atau ISBN ke CitationEasy dan dapatkan sitasi {style} yang terformat sempurna dalam hitungan detik, siap untuk {listLower} Anda.",
    faqWhatQ: "Apa itu {list} {style}?",
    faqWhatA:
      "{list} {style} adalah bagian di akhir makalah Anda yang mencantumkan semua sumber yang Anda sitasi dalam teks, diformat sesuai pedoman {fullName} ({edition}). Bagian ini memungkinkan pembaca menemukan dan memverifikasi setiap sumber yang Anda rujuk.",
    faqFormatQ: "Bagaimana cara memformat {listLower} {style}?",
    faqFormatA:
      'Mulai di halaman baru, beri judul "{list}," dan cantumkan semua sumber yang Anda sitasi dalam makalah. Ikuti aturan {style} yang spesifik untuk indentasi gantung, spasi, urutan abjad atau nomor, dan huruf miring.',
    faqDifferenceQ: "Apa perbedaan antara {listLower} dan bibliografi?",
    faqDifferenceA:
      '{listLower} hanya mencakup sumber yang langsung Anda sitasi dalam makalah, sedangkan bibliografi juga dapat mencakup sumber yang Anda pelajari tetapi tidak disitasi. Dalam {style} ({edition}), daftar di akhir makalah disebut "{list}."',
  },

  // /annotated-bibliography/<style>. `whatTypes` carries `**bold**` inline markup.
  //
  // `exampleAnnotation` is a specimen annotation, not a citation: it is ordinary prose
  // about an imaginary source and translates like any other paragraph. The reference
  // entry printed above it does not — that comes from `DETAILED_STYLES` and stays as
  // the style wrote it.
  annotatedBibPage: {
    metaTitle: "Panduan & Contoh Daftar Pustaka Beranotasi {style} [2026]",
    metaDescription:
      "Pelajari cara menulis daftar pustaka beranotasi dalam gaya {style} ({edition}). Mencakup aturan format, contoh entri, dan tips untuk daftar pustaka beranotasi {fullName}.",
    ogTitle: "Daftar pustaka beranotasi {style}",
    ogDescription:
      "Cara memformat daftar pustaka beranotasi dalam gaya {style}.",
    ogImageTitle: "Daftar Pustaka Beranotasi {style}",
    ogKind: "{style} {edition}",
    breadcrumb: "Daftar Pustaka Beranotasi {style}",
    heading: "Daftar Pustaka Beranotasi {style}",
    lead: "Daftar pustaka beranotasi adalah daftar sitasi sumber yang masing-masing disertai paragraf deskriptif atau evaluatif singkat. Dalam format {style} ({edition}), setiap entri dimulai dengan referensi yang diformat dengan benar, diikuti oleh anotasi yang meringkas, menilai, atau merefleksikan sumber tersebut. Panduan ini memandu Anda melalui aturan, format, dan contoh yang dibutuhkan untuk membuat daftar pustaka beranotasi {style} yang rapi.",
    whatHeading: "Apa Itu Daftar Pustaka Beranotasi?",
    whatBody:
      "Daftar pustaka beranotasi melampaui {listLower} standar dengan menambahkan paragraf singkat setelah setiap sitasi. Anotasi ini memberi pembaca wawasan tentang isi, kualitas, dan relevansi sumber. Dosen sering menugaskan daftar pustaka beranotasi untuk membantu mahasiswa mengevaluasi sumber secara kritis dan menunjukkan bagaimana setiap sumber berkontribusi pada topik penelitian mereka.",
    whatTypes:
      "Ada tiga jenis anotasi yang umum: anotasi **deskriptif** yang meringkas sumber, anotasi **evaluatif** yang menilai kualitas dan keandalan karya, dan anotasi **kombinasi** yang melakukan keduanya. Instruksi tugas Anda seharusnya menyebutkan jenis mana yang harus digunakan.",
    rulesHeading: "Aturan Daftar Pustaka Beranotasi {style}",
    rulesIntro:
      "Ikuti aturan berikut saat memformat daftar pustaka beranotasi dalam {fullName}:",
    exampleHeading: "Contoh Entri Daftar Pustaka Beranotasi",
    exampleIntro:
      "Berikut contoh entri daftar pustaka beranotasi {style} untuk {sourceType}:",
    exampleAnnotation:
      "Sumber ini memberikan gambaran menyeluruh tentang topik tersebut, menyajikan argumen yang didukung dengan baik dan berdasarkan bukti empiris. Penulis mengacu pada berbagai sumber primer dan sekunder untuk membangun argumen yang meyakinkan. Metodologinya ketat dan temuannya disajikan dengan jelas, menjadikan karya ini sumber daya yang berharga untuk memahami topik tersebut. Sumber ini sangat berguna untuk membangun kerangka teoretis proyek penelitian dan menawarkan perspektif yang melengkapi karya-karya lain dalam daftar pustaka.",
    tipsHeading: "Tips Menulis Anotasi {style}",
    tipSummarize:
      "Mulailah dengan meringkas sumber dalam dua hingga tiga kalimat, lalu tambahkan evaluasi Anda tentang kekuatan, keterbatasan, dan relevansinya.",
    tipTone:
      "Gunakan sudut pandang orang ketiga dan nada akademik di seluruh anotasi Anda. Hindari bahasa santai atau refleksi sudut pandang orang pertama kecuali diminta oleh dosen Anda.",
    tipLength:
      "Jaga setiap anotasi antara 100 hingga 200 kata. Buatlah ringkas dan fokus pada aspek terpenting dari sumber tersebut.",
    tipRelevance:
      "Jelaskan bagaimana sumber ini cocok dengan penelitian Anda secara keseluruhan. Jelaskan perspektif atau bukti unik apa yang disumbangkannya.",
    tipCitation:
      "Pastikan bagian sitasi setiap entri mengikuti aturan format {fullName} secara tepat sebelum menulis anotasinya.",
    ctaHeading: "Buat Daftar Pustaka Beranotasi Anda Secara Otomatis",
    ctaBody:
      "Gunakan Pembuat Daftar Pustaka Beranotasi CitationEasy untuk menghasilkan sitasi {style} yang diformat dengan benar, lalu tambahkan anotasi Anda.",
    ctaButton: "Buka Pembuat Daftar Pustaka Beranotasi →",
    faqWhatQ: "Apa itu daftar pustaka beranotasi dalam gaya {style}?",
    faqWhatA:
      "Daftar pustaka beranotasi dalam gaya {style} ({edition}) adalah daftar sitasi yang diformat dalam gaya {fullName}, masing-masing diikuti paragraf singkat yang meringkas, menilai, atau merefleksikan sumber tersebut. Ini membantu pembaca memahami relevansi dan kualitas setiap sumber.",
    faqLengthQ: "Seberapa panjang anotasi seharusnya?",
    faqLengthA:
      "Anotasi biasanya sepanjang 100 hingga 200 kata. Beberapa tugas mungkin memerlukan anotasi yang lebih pendek atau lebih panjang tergantung kedalaman analisis yang diharapkan. Selalu periksa pedoman dosen Anda untuk persyaratan panjang yang spesifik.",
    faqIncludeQ: "Apa yang harus dicantumkan dalam anotasi?",
    faqIncludeA:
      "Anotasi harus mencakup ringkasan singkat argumen atau temuan utama sumber, evaluasi kredibilitas dan kegunaan sumber, serta refleksi tentang bagaimana sumber tersebut cocok dengan penelitian Anda. Beberapa anotasi bersifat murni deskriptif, sementara yang lain mencakup analisis kritis.",
  },

  guidePage: {
    byline: "Oleh {author}",
    published: "Diterbitkan {date}",
    updated: "Diperbarui {date}",
    readingTime: "other:{count} menit baca",
    wordCount: "other:{count} kata",
  },

  // /guides hub, /guides/<category> index pages, and the chrome around each guide
  guideLibrary: {
    eyebrow: "Perpustakaan panduan",
    browseByCategory: "Jelajahi berdasarkan kategori",
    recentlyUpdated: "Baru diperbarui",
    allGuides: "Semua panduan",
    guideCount: "other:{count} panduan",
    updatedOn: "Diperbarui {date}",
    minRead: "other:{count} menit baca",
    onThisPage: "Di halaman ini",
    viewAllInCategory: "Semua panduan {category}",
    moreInCategory: "Lainnya di {category}",
    aboutThisGuide: "Tentang panduan ini",
    provenance:
      "Ditulis oleh {author}. Diterbitkan {published}; terakhir diperbarui {updated}.",
    categoryIntroSuffix:
      "Setiap panduan gratis, ditulis untuk mahasiswa dan peneliti, dan diberi tanggal agar Anda tahu kapan terakhir diperiksa.",
    photoCredit: "Foto: {author}, {source} ({license})",
    imageAlt: "Foto yang mengilustrasikan panduan {category}",
    imageSourceCommons: "Wikimedia Commons",
    apaStyleName: "Gaya APA",
    apaStyleDescription:
      "Cara mengutip situs web, artikel jurnal, buku, video, dan lainnya dalam APA edisi ke-7, dengan contoh daftar pustaka dan kutipan dalam teks.",
    mlaStyleName: "Gaya MLA",
    mlaStyleDescription:
      "Cara mengutip semua sumber umum dalam MLA edisi ke-9, dari halaman web dan artikel hingga puisi, drama, film, dan materi kuliah.",
    chicagoStyleName: "Gaya Chicago",
    chicagoStyleDescription:
      "Panduan Chicago Manual of Style yang mencakup kutipan catatan-bibliografi dan penulis-tanggal untuk buku, artikel, arsip, dokumen pemerintah, dan media.",
    styleComparisonsName: "Perbandingan Gaya",
    styleComparisonsDescription:
      "Perbandingan berdampingan APA, MLA, Chicago, Harvard, Vancouver, IEEE, dan lainnya, plus saran gaya mana yang diharapkan bidang Anda.",
    researchMethodsName: "Metode Penelitian",
    researchMethodsDescription:
      "Cara merencanakan makalah penelitian, meninjau literatur, mencatat, mengevaluasi sumber, menghindari plagiarisme, dan menyusun bibliografi.",
    academicWritingName: "Penulisan Akademik",
    academicWritingDescription:
      "Panduan menulis abstrak, pendahuluan, kesimpulan, pernyataan tesis, bagian metodologi, dan prosa akademik yang jelas.",
    fieldSpecificName: "Per Bidang",
    fieldSpecificDescription:
      "Panduan kutipan untuk masing-masing disiplin, dari psikologi, sejarah, dan sastra hingga kedokteran, teknik, hukum, dan keperawatan.",
    sourceEvaluationName: "Evaluasi Sumber",
    sourceEvaluationDescription:
      "Cara menilai kredibilitas, membedakan sumber ilmiah dan populer, menggunakan Google Scholar dan basis data perpustakaan, serta mengenali bias.",
    citationHelpName: "Bantuan Kutipan",
    citationHelpDescription:
      "Jawaban untuk kasus sulit: tanpa penulis atau tanggal, banyak penulis, PDF, alat AI, kasus hukum, serta impor atau ekspor kutipan.",
  },

  common: {
    backToGuides: "← Kembali ke panduan",
    free: "Gratis",
    noSignup: "Tanpa pendaftaran",
    backToHome: "Kembali ke pembuat sitasi",
    inEnglish: "Dalam bahasa Inggris",
    viewInEnglish: "Lihat dalam bahasa Inggris",
    availableInEnglish:
      "Halaman ini tersedia dalam bahasa Inggris dengan penjelasan lebih lengkap.",
    otherLanguages: "Bahasa lain",
    skipToContent: "Lompat ke konten",
    cookieNotice:
      "Kami menggunakan cookie untuk analitik dan iklan agar CitationEasy tetap gratis.",
    privacyPolicy: "Kebijakan Privasi",
    accept: "Terima",
    decline: "Tolak",
    advertisement: "Iklan",
  },
  legalPage: {
    backLink: "← Kembali ke Pembuat Sitasi",
    effective: "Tanggal berlaku:",
    updated: "Terakhir diperbarui:",
  },
};

export default id;
